/* GTA VI Konfigurator · Demo v1.1 · Verhalten (Zustand, Buehne, Welt, Crew, Warenkorb-Ziel) */
(() => {
  'use strict';
  const I = window.__iwg, B = I.B, R = I.R, d = document, h = d.documentElement;
  const $ = (id) => d.getElementById(id);
  const RM = matchMedia('(prefers-reduced-motion: reduce)');
  const MOB = matchMedia('(max-width: 899px)');
  const DEBUG = new URLSearchParams(location.search).get('debug') === '1';
  const EASE = 'cubic-bezier(.22,1,.36,1)';
  const CREW_DEF = ['jason-bandana', 'boobie', 'real-dimez'];
  const MINI_H = 72;
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const pick = (s) => ({ c: s.c, w: s.w, s: s.s, n: s.n, m: s.m, g: s.g, du: s.du ? 1 : 0 });
  const P = I.P; /* DU ALS CHARAKTER: Wer, Anzahl, Fotos (Object-URLs), Name, Haekchen. Nur im Browser, nie in der URL. */
  const wslug = (name) => Object.keys(I.WS).find((k) => I.WS[k] === name) || 'original';
  const famIdx = (f) => R.FAMS.findIndex((x) => x.f === f);
  /* Familien-Karte: fruehere Wahl in dieser Familie, sonst das guenstigste Mitglied in Groesse g */
  const famMat = (f, g) => (lastInFam[f] != null ? lastInFam[f] : I.cheap(g, R.FAMS[famIdx(f)].m));
  const vid = R.vid;

  /* ------------------------------------------------------------ Zustand */
  let st = Object.assign(pick(I.st), { view: 'motiv' });
  let crew = [pick(st)], active = 0;
  let CAT = null;
  let lastNonCanvas = B.mats[st.m].c ? null : st.m;
  const lastInFam = {};
  lastInFam[R.FAMS[R.famOf(st.m)].f] = st.m;
  let noteState = I.notice || '';
  let curOrn = h.getAttribute('data-orn'), curBg = B.chars[st.c].bg;
  let shownPrice = R.price(st), shownTotal = R.total(crew);
  let buying = false; /* DU-Kauf laeuft: Knoepfe zeigen den Upload, zweiter Klick zaehlt nicht */

  let catResolve; const catReady = new Promise((r) => (catResolve = r));

  const world = $('iwg-world');
  const imgs = [$('st-a'), $('st-b')];
  const ambs = Array.from(d.querySelectorAll('.st-amb img'));
  const card = d.querySelector('.st-card');
  const nameSp = Array.from(d.querySelectorAll('.w-name span'));
  const live = $('iwg-live');
  const mini = $('iwg-mini'), miniImg = $('mini-img');
  let cur = 0, ambCur = 0, nCur = 0, swapTok = 0, renderTok = 0, ornT = 0, liveT = 0, tw = 0, loadT = 0;
  let ambWant = ambs[0].getAttribute('src') || '';

  /* Crew aus der URL: crew=ad (Ad-Crew vorbelegen) oder crew=slug.welt.stil.name.material.groesse_... plus a=Index */
  (function bootCrew() {
    if (!B.offer3for2) return;
    const u = new URLSearchParams(location.search), cv = (u.get('crew') || '').trim().toLowerCase();
    if (!cv) return;
    let list = [], act = 0;
    if (cv === 'ad') {
      list = [pick(st)];
      CREW_DEF.forEach((sl) => {
        const ci = B.chars.findIndex((c) => c.s === sl);
        if (ci < 0 || list.length >= 3 || list.some((e) => e.c === ci)) return;
        const e = { c: ci, w: 0, s: st.s, n: st.n, m: st.m, g: st.g };
        I.norm(e); list.push(e);
      });
    } else {
      list = cv.split('_').slice(0, 3).map((x) => {
        const a = x.split('.'), q = new URLSearchParams();
        ['c', 'w', 's', 'n', 'm', 'g'].forEach((k, i) => a[i] && q.set(k, a[i]));
        const e = I.parse(q.toString()); I.norm(e); return e;
      });
      const ai = parseInt(u.get('a'), 10);
      act = ai >= 0 && ai < list.length ? ai : 0;
      list[act] = pick(st); /* c/w/s/n/m/g der URL gelten fuer den aktiven Platz */
    }
    if (list.length < 2) return;
    crew = list; active = act;
  })();

  /* ------------------------------------------------------------ setState */
  function setState(patch, src) {
    const prev = Object.assign({}, st);
    if ('c' in patch && patch.c !== st.c) {
      const wn = B.chars[st.c].w[st.w];
      const wi = B.chars[patch.c].w.indexOf(wn);
      st.w = wi < 0 ? 0 : wi; /* fehlt die Farbwelt, gilt Original */
    }
    Object.assign(st, patch);
    const changed = Object.keys(patch).find((k) => k !== 'view');
    /* 1 normalisieren */
    const note = I.norm(st, changed);
    if (!B.mats[st.m].c) lastNonCanvas = st.m;
    lastInFam[R.FAMS[R.famOf(st.m)].f] = st.m;
    if (note) noteState = note;
    else if (noteState === 'canvas' && (['c', 'w', 's', 'n'].some((k) => k in patch) || !B.mats[st.m].c || st.n === 0)) noteState = '';
    else if (noteState === 'mit' && changed) noteState = '';
    if (!('view' in patch)) {
      if (['c', 'w', 's', 'n'].some((k) => k in patch)) st.view = 'motiv';
      else if (['g', 'm'].some((k) => k in patch)) st.view = 'produkt';
    }
    if (st.du) st.view = 'motiv'; /* fuer Portraets gibt es noch keine Produktfotos */
    crew[active] = pick(st);
    return render(prev, { src, patch, url: true });
  }

  /* Gibt ein Promise zurueck, das aufloest, sobald das neue Buehnenbild dekodiert ist (oder nicht noetig war) */
  function render(prev, o) {
    o = o || {};
    const focusKey = keepFocus();
    const rt = ++renderTok;
    h.setAttribute('data-view', st.view);
    h.setAttribute('data-mode', st.du ? 'du' : 'char');
    hideMsg();
    /* 4 Buehne zuerst: die Welt wechselt erst, wenn das Bild bereit ist (max. 300 ms) */
    const ready = updStage();
    Promise.race([ready, sleep(RM.matches ? 0 : 300)]).then(() => { if (rt === renderTok) applyWorld(); });
    /* 5 Thumbs, 6 [data-f] (Preise per Tween) */
    R.update(st, crew, active, { skip: ['price', 'total', 'cta'] });
    tweenPrices();
    updMini();
    syncDu();
    /* 9 URL */
    if (o.url) writeURL();
    /* 10 Ansage */
    announce();
    updNote();
    restoreFocus(focusKey);
    revealSel(false);
    const p = o.patch || {};
    if (o.src && ('c' in p || 'w' in p) && !RM.matches) sparks(o.src);
    if (DEBUG) debug();
    return ready;
  }
  /* 2 Tokens, 3 Attribute (+ 8 theme-color), Ornament und Name */
  function applyWorld() {
    const c = B.chars[st.c];
    I.set(st, 0);
    if (c.o !== curOrn) swapOrn(c.o);
    if (c.bg !== curBg) swapName(c.bg);
  }

  /* Fokus nach Neuaufbau einer Gruppe wiederherstellen */
  function keepFocus() {
    const a = d.activeElement;
    if (!a || a === d.body) return null;
    for (const k of ['data-set', 'data-slot', 'data-add', 'data-del']) if (a.hasAttribute(k)) return [k, a.getAttribute(k), a.parentElement && a.parentElement.closest('[id]')];
    return null;
  }
  function restoreFocus(k) {
    if (!k || d.activeElement && d.activeElement !== d.body && d.contains(d.activeElement)) return;
    const root = k[2] && d.contains(k[2]) ? k[2] : d;
    const el = root.querySelector('[' + k[0] + '="' + k[1] + '"]') || (k[0] === 'data-del' ? root.querySelector('.slot.act .slot-b') : null);
    if (el) el.focus({ preventScroll: true });
  }

  /* gewaehlte Kachel im Scroller sichtbar halten */
  function revealSel(instant) {
    ['t-char', 't-mat'].forEach((id) => {
      const g = $(id);
      if (!g || g.scrollWidth <= g.clientWidth + 2) return;
      const b = g.querySelector('[aria-checked=true]');
      if (!b) return;
      const gl = g.getBoundingClientRect(), bl = b.getBoundingClientRect();
      if (bl.left >= gl.left + 10 && bl.right <= gl.right - 10) return;
      g.scrollTo({ left: g.scrollLeft + (bl.left - gl.left) - (gl.width - bl.width) / 2, behavior: instant || RM.matches ? 'auto' : 'smooth' });
    });
  }

  /* ------------------------------------------------------------ Buehne */
  function mockUrl(s, w) { return B.cdn + CAT.mock[B.chars[s.c].s][I.di(s)][B.mats[s.m].mg] + '&width=' + w; }
  function stageWant() {
    const dd = I.di(st);
    if (st.du) return { src: R.duImg(st, 600), srcset: R.duImg(st, 600) + ' 600w, ' + R.duImg(st, 960) + ' 960w', mock: false };
    if (st.view === 'produkt' && CAT) {
      return { src: mockUrl(st, 750), srcset: [500, 750, 1000].map((w) => mockUrl(st, w) + ' ' + w + 'w').join(', '), mock: true };
    }
    return { src: I.flat(st.c, dd, 600), srcset: I.srcset(st.c, dd), mock: false };
  }
  function setLoading(on, tok) {
    clearTimeout(loadT);
    if (on) loadT = setTimeout(() => { if (tok === swapTok) card.classList.add('loading'); }, 180);
    else card.classList.remove('loading');
  }
  async function updStage() {
    const tok = ++swapTok;
    swapAmb(R.th(st, 120));
    if (st.view === 'produkt' && !CAT) { await catReady; if (tok !== swapTok) return; }
    const w = stageWant();
    const alt = st.du ? 'Beispiel: Porträt im GTA-VI-Style, ' + R.summary(st) : R.cname(st.c) + ', ' + R.summary(st) + (w.mock ? ', Produktfoto' : '');
    const now = imgs[cur], other = imgs[1 - cur];
    /* Ziel steht schon: laufende Ueberblendung des anderen Bildes abbrechen (schnelles Zurueckwaehlen) */
    if (now.getAttribute('src') === w.src) {
      now.alt = alt;
      other.getAnimations().forEach((a) => a.cancel());
      other.classList.remove('top');
      now.getAnimations().forEach((a) => a.cancel());
      setLoading(false);
      return;
    }
    /* Ziel blendet gerade schon ein: laufen lassen */
    if (other.getAttribute('src') === w.src && other.classList.contains('top')) { other.alt = alt; setLoading(false); return; }
    const nx = other;
    nx.getAnimations().forEach((a) => a.cancel());
    now.getAnimations().forEach((a) => a.cancel());
    nx.classList.remove('top');
    nx.classList.toggle('mock', w.mock);
    nx.sizes = I.SIZES; nx.srcset = w.srcset; nx.src = w.src; nx.alt = alt;
    setLoading(true, tok);
    let ok = true;
    try { await nx.decode(); } catch (e) { ok = nx.complete && nx.naturalWidth > 0; }
    if (tok !== swapTok) return;
    setLoading(false);
    if (!ok) return; /* Bild fehlt oder Abbruch: das alte bleibt voll stehen */
    fade(nx);
  }
  /* Neues Bild ueber das alte blenden. Jeder neue Wechsel bricht die Animation ab (dann bleibt alles wie es war). */
  async function fade(nx) {
    const old = imgs[1 - imgs.indexOf(nx)];
    const dur = RM.matches ? 0 : 420;
    nx.classList.add('top');
    const an = nx.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: dur, easing: EASE });
    /* Motiv und Produktfoto liegen auf verschiedenen Flaechen: dann das alte mit ausblenden */
    const ao = nx.classList.contains('mock') !== old.classList.contains('mock')
      ? old.animate([{ opacity: 1 }, { opacity: 0 }], { duration: dur, easing: EASE, fill: 'forwards' }) : null;
    try { await an.finished; } catch (e) { if (ao) ao.cancel(); return; }
    nx.classList.add('on'); nx.classList.remove('top');
    old.classList.remove('on');
    if (ao) ao.cancel();
    cur = imgs.indexOf(nx);
    if (!RM.matches) { card.classList.remove('shine'); void card.offsetWidth; card.classList.add('shine'); }
  }
  /* Ambilight: nur das zuletzt gewuenschte Bild darf umschalten */
  function swapAmb(src) {
    ambWant = src;
    const now = ambs[ambCur], nx = ambs[1 - ambCur];
    if (now.getAttribute('src') === src) { nx.onload = null; return; }
    const show = () => {
      if (nx.getAttribute('src') !== ambWant) return;
      nx.classList.add('on'); now.classList.remove('on'); ambCur = ambs.indexOf(nx);
    };
    nx.onload = show;
    if (nx.getAttribute('src') === src && nx.complete && nx.naturalWidth) { show(); return; }
    nx.src = src;
  }

  /* Mini-Vorschau (mobil, sobald die Buehne aus dem Bild ist) */
  function updMini() {
    if (!miniImg) return;
    const mock = st.view === 'produkt' && CAT;
    const src = mock ? mockUrl(st, 200) : R.th(st, 120);
    miniImg.setAttribute('data-src', src);
    mini.classList.toggle('mock', !!mock);
    if (mini.classList.contains('on') && miniImg.getAttribute('src') !== src) miniImg.src = src;
  }
  let stageVis = true, heroVis = true;
  function updMiniVis() {
    const on = MOB.matches && !stageVis && heroVis;
    if (on === mini.classList.contains('on')) return;
    mini.classList.toggle('on', on);
    h.classList.toggle('mini-on', on);
    if (on) { const s = miniImg.getAttribute('data-src'); if (s && miniImg.getAttribute('src') !== s) miniImg.src = s; }
  }
  const mio = new IntersectionObserver((es) => {
    es.forEach((en) => {
      if (en.target.id === 'iwg-stage') stageVis = en.isIntersecting && en.intersectionRatio >= 0.3;
      else heroVis = en.isIntersecting;
    });
    updMiniVis();
  }, { rootMargin: '-52px 0px 0px 0px', threshold: [0, 0.3, 0.6] });
  mio.observe($('iwg-stage')); mio.observe($('konfigurator'));
  MOB.addEventListener && MOB.addEventListener('change', updMiniVis);
  mini.addEventListener('click', () => scrollTo({ top: 0, behavior: RM.matches ? 'auto' : 'smooth' }));

  /* ------------------------------------------------------------ Welt: Ornament und Name */
  function swapOrn(o) {
    curOrn = o;
    clearTimeout(ornT);
    if (RM.matches) { h.setAttribute('data-orn', o); return; }
    world.classList.add('swap');
    ornT = setTimeout(() => { h.setAttribute('data-orn', o); world.classList.remove('swap'); }, 260);
  }
  /* Schriftmetrik (Bebas): Grundlinie exakt auf --nb, Versalhoehe fuer die Groesse */
  function metrics() {
    try {
      const c = d.createElement('canvas').getContext('2d');
      c.font = '100px "Bebas Neue"';
      const m = c.measureText('H');
      return { a: (m.fontBoundingBoxAscent || 90) / 100, d: (m.fontBoundingBoxDescent || 30) / 100, cap: (m.actualBoundingBoxAscent || 70) / 100 };
    } catch (e) { return { a: 0.9, d: 0.3, cap: 0.7 }; }
  }
  let FM = metrics();
  const col = d.querySelector('.stage-col');
  /* Name nur am Desktop: zentriert auf die Buehne, hoechstens 1,2 x Buehnenbreite, Grundlinie wie auf dem Poster */
  function fitName(sp) {
    if (MOB.matches) return;
    const r = col.getBoundingClientRect();
    const nb = 96 + r.height * 0.22;
    world.style.setProperty('--nb', nb.toFixed(1) + 'px');
    world.style.setProperty('--nx', (r.left + r.width / 2).toFixed(1) + 'px');
    sp.style.fontSize = '100px';
    const w = sp.getBoundingClientRect().width || 300;
    const capMax = Math.min(0.30 * innerHeight, nb - 52 - 18);
    const stW = $('iwg-stage').offsetWidth || r.width;
    const fs = Math.max(28, Math.min(1.2 * stW / (w / 100), capMax / FM.cap));
    sp.style.fontSize = fs.toFixed(1) + 'px';
    sp.style.bottom = (-(0.7 - FM.a + FM.d) / 2 * fs).toFixed(1) + 'px';
  }
  function swapName(bg) {
    curBg = bg;
    const old = nameSp[nCur], nx = nameSp[1 - nCur];
    nx.textContent = bg; fitName(nx);
    old.classList.remove('on');
    setTimeout(() => nx.classList.add('on'), RM.matches ? 0 : 140);
    nCur = 1 - nCur;
  }
  let fitT = 0;
  function refit() { clearTimeout(fitT); fitT = setTimeout(() => { FM = metrics(); nameSp.forEach((s) => s.textContent && fitName(s)); updDuName(); }, 120); }
  /* Name nur im Hero: sobald der Konfigurator nach oben weg ist, ausblenden (sonst Bruchstuecke zwischen den Abschnitten) */
  const hero = $('konfigurator');
  let nameOff = null, scT = 0;
  function onScroll() {
    scT = 0;
    const off = hero.getBoundingClientRect().bottom < innerHeight * 0.75;
    if (off !== nameOff) { nameOff = off; world.classList.toggle('name-off', off); }
  }
  addEventListener('scroll', () => { if (!scT) scT = requestAnimationFrame(onScroll); }, { passive: true });

  /* ------------------------------------------------------------ Preise */
  const fEls = {};
  const fl = (k) => fEls[k] || (fEls[k] = Array.from(d.querySelectorAll('[data-f="' + k + '"]')));
  function fill(k, v) { fl(k).forEach((e) => { if (e.textContent !== v) e.textContent = v; }); }
  function ctaLabel(t) { return buying ? (P.photos.length > 1 ? 'FOTOS WERDEN HOCHGELADEN …' : 'FOTO WIRD HOCHGELADEN …') : R.ctaText(t, crew); }
  function tweenPrices() {
    const p1 = R.price(st), t1 = R.total(crew), p0 = shownPrice, t0 = shownTotal;
    const draw = (p, t) => { fill('price', R.eur(p)); fill('total', R.eur(t)); fill('cta', ctaLabel(t)); shownPrice = p; shownTotal = t; };
    cancelAnimationFrame(tw);
    if (RM.matches || (p0 === p1 && t0 === t1)) { draw(p1, t1); return; }
    const s0 = performance.now();
    const step = (now) => {
      const k = Math.min(1, (now - s0) / 500), e = 1 - Math.pow(1 - k, 3);
      draw(Math.round(p0 + (p1 - p0) * e), Math.round(t0 + (t1 - t0) * e));
      if (k < 1) tw = requestAnimationFrame(step);
    };
    tw = requestAnimationFrame(step);
  }

  /* ------------------------------------------------------------ Warenkorb-Ziel */
  /* Die Links setzt R.update (IDs stehen im Boot-Block). Crew: href ist #kaufbox, der Klick schickt das Formular. */
  d.addEventListener('click', (e) => {
    const a = e.target.closest('[data-buy]');
    if (!a) return;
    if (crew.some((x) => x.du)) { e.preventDefault(); duBuy(a); return; } /* Portraet: Formular mit Foto an /cart/add */
    if (crew.length < 2) return; /* einzelnes Werk: normaler Link mit fertiger ID */
    e.preventDefault();
    $('crew-form').submit();
  });

  /* ------------------------------------------------------------ URL */
  function writeURL() {
    const u = new URL(location.href), p = u.searchParams, c = B.chars[st.c];
    ['charakter', 'farbe', 'welt', 'style', 'stil', 'name', 'material', 'groesse', 'size'].forEach((k) => p.delete(k));
    p.set('c', st.du ? 'du' : c.s); p.set('w', wslug(c.w[st.w])); p.set('s', I.STI[st.s]); p.set('n', I.NAM[st.n]);
    p.set('m', B.mats[st.m].s); p.set('g', B.sizes[st.g].s);
    p.delete('perso');
    if (crew.some((e) => e.du)) p.set('wer', P.wer); else p.delete('wer'); /* Name und Foto nie in die URL */
    if (crew.length > 1) {
      p.set('crew', crew.map((e) => { const x = B.chars[e.c]; return [e.du ? 'du' : x.s, wslug(x.w[e.w]), I.STI[e.s], I.NAM[e.n], B.mats[e.m].s, B.sizes[e.g].s].join('.'); }).join('_'));
      p.set('a', String(active));
    } else { p.delete('crew'); p.delete('a'); }
    try { history.replaceState(history.state, '', u.pathname + '?' + p.toString() + u.hash); } catch (e) { /* file:// */ }
  }

  /* ------------------------------------------------------------ Ansage, Hinweis */
  function announce() {
    clearTimeout(liveT);
    liveT = setTimeout(() => {
      const c = B.chars[st.c];
      live.textContent = (st.du ? ['Du als Charakter', R.werL(), R.wnm(st, st.w), R.STL[st.s], R.NML[st.n], B.sizes[st.g].l, B.mats[st.m].L, R.eur(R.price(st))]
        : [R.cname(st.c), c.w[st.w], R.STL[st.s], R.NML[st.n], B.sizes[st.g].l, B.mats[st.m].L, R.eur(R.price(st))]).join(', ') +
        (crew.length > 1 ? '. Crew mit ' + crew.length + ' Kunstwerken, zusammen ' + R.eur(R.total(crew)) : '');
    }, 300);
  }
  function updNote() {
    const boxes = { canvas: $('note'), mit: $('note3') };
    Object.keys(boxes).forEach((k) => {
      const box = boxes[k]; if (!box) return;
      if (noteState !== k) { box.hidden = true; return; }
      box.hidden = false;
      box.querySelector('[data-note]').textContent = k === 'canvas'
        ? 'Auf Leinwand gibt es dieses Motiv ohne Namen. Wir haben auf Ohne Name umgestellt.'
        : 'Mit Name gibt es als Poster, Acrylglas und Aluminium. Wir haben das ' + B.mats[st.m].L.replace(/ im Metallrahmen$/, '') + ' gewählt.';
    });
    const btn = $('note-btn');
    if (btn) btn.hidden = noteState !== 'canvas';
  }

  /* ------------------------------------------------------------ Funken */
  function sparks(el) {
    try { navigator.vibrate && navigator.vibrate(10); } catch (e) { /* egal */ }
    const r = el.getBoundingClientRect();
    if (!r.width) return;
    const cx = r.left + r.width / 2, cy = r.top + r.height / 2, t = I.tok(st);
    const cols = [t[3], t[7], t[6], t[0], t[1], '#FFFFFF'];
    for (let i = 0; i < 10; i++) {
      const s = d.createElement('i'), c = cols[i % cols.length];
      s.className = 'iwg-spark'; s.style.background = c; s.style.boxShadow = '0 0 10px ' + c;
      d.body.appendChild(s);
      const a = (i / 10) * Math.PI * 2 + Math.random() * 0.6, dist = 34 + Math.random() * 52, sz = 0.6 + Math.random() * 0.9;
      const an = s.animate([
        { transform: 'translate(' + cx + 'px,' + cy + 'px) scale(' + sz + ')', opacity: 1 },
        { transform: 'translate(' + (cx + Math.cos(a) * dist) + 'px,' + (cy + Math.sin(a) * dist) + 'px) scale(0)', opacity: 0 }
      ], { duration: 600, easing: EASE });
      an.onfinish = () => s.remove();
    }
  }

  /* ------------------------------------------------------------ Eingaben */
  const tapped = {};
  /* Mobil: erster Tap je Stufe scrollt zur naechsten. Nach Stufe 1 erst, wenn das neue Motiv auf der Buehne steht. */
  function autoScroll(btn, ev, ready) {
    if (!MOB.matches || !ev || ev.detail === 0) return;
    const step = btn.closest('.iwg-step');
    if (!step) return;
    const n = +step.getAttribute('data-step');
    if (n >= 4 || tapped[n]) return;
    tapped[n] = 1;
    const y0 = scrollY;
    const go = () => {
      if (Math.abs(scrollY - y0) > 40) return; /* Kunde scrollt selbst: nicht reinfunken */
      const nx = $('stufe-' + (n + 1));
      const top = nx.getBoundingClientRect().top;
      const target = n === 3 ? Math.max(MINI_H + 12, innerHeight * 0.5) : MINI_H + 12;
      if (top < target + 40) return;
      scrollTo({ top: top + scrollY - target, behavior: RM.matches ? 'auto' : 'smooth' });
    };
    if (n === 1) Promise.race([ready || Promise.resolve(), sleep(1200)]).then(() => setTimeout(go, RM.matches ? 0 : 750));
    else setTimeout(go, 350);
  }
  function pickFam(f, src) {
    const F = R.FAMS[famIdx(f)];
    if (F.m.indexOf(st.m) >= 0) { if (st.view !== 'produkt') setState({ view: 'produkt' }, src); return; }
    setState({ m: famMat(f, st.g) }, src);
  }
  function scrollToEl(el, off) {
    const y = el.getBoundingClientRect().top + scrollY - (off || 64);
    scrollTo({ top: y, behavior: RM.matches ? 'auto' : 'smooth' });
  }
  d.addEventListener('click', (e) => {
    const t = e.target;
    const set = t.closest('[data-set]');
    if (set) {
      const v = set.getAttribute('data-set');
      if (!v) return;
      const [k, val] = v.split(':');
      let ready = null;
      if (k === 'view') ready = setState({ view: val }, set);
      else if (k === 'fam') {
        pickFam(val, set);
        if (set.hasAttribute('data-jump')) scrollToEl($('stufe-4'), MOB.matches ? MINI_H + 12 : 64);
      } else {
        const p = {}; p[k] = +val;
        if (k === 'c' && st.du) p.du = 0; /* Charakter statt Portraet: Foto, Name und Wer bleiben gespeichert */
        else if (p[k] === st[k] && k !== 'n') { autoScroll(set, e); return; }
        ready = setState(p, set);
      }
      autoScroll(set, e, ready);
      return;
    }
    const slot = t.closest('[data-slot]');
    if (slot) { activate(+slot.getAttribute('data-slot'), slot); return; }
    const del = t.closest('[data-del]');
    if (del) { removeSlot(+del.getAttribute('data-del')); return; }
    if (t.closest('[data-add]') || t.closest('#add-crew')) { addCrew(t.closest('button')); return; }
    if (t.closest('#note-btn')) {
      noteState = '';
      setState({ n: 0, m: lastNonCanvas != null ? lastNonCanvas : I.cheap(st.g, null, I.noCanvas) }, null);
      const nb = d.querySelector('#t-name [data-set="n:0"]'); /* der Knopf verschwindet: Fokus auf "Mit Name" */
      if (nb) nb.focus({ preventScroll: true });
      return;
    }
    if (t.closest('#take-crew')) { takeCrew(t.closest('button')); return; }
    if (duClick(t, e)) return;
    if (t.closest('#tc-more')) {
      const w = $('char-wrap'); w.classList.add('open'); $('tc-more').setAttribute('aria-expanded', 'true');
      const first = d.querySelector('#t-char .tc.x'); if (first) first.focus({ preventScroll: true });
    }
  });
  d.addEventListener('keydown', (e) => {
    const r = e.target.closest && e.target.closest('[role=radio]');
    if (!r) return;
    const g = r.closest('[role=radiogroup]');
    if (!g) return;
    const k = e.key;
    let dir = 0;
    if (k === 'ArrowRight' || k === 'ArrowDown') dir = 1;
    else if (k === 'ArrowLeft' || k === 'ArrowUp') dir = -1;
    else if (k === 'Home') dir = 'h';
    else if (k === 'End') dir = 'e';
    else return;
    e.preventDefault();
    const list = Array.from(g.querySelectorAll('[role=radio]')).filter((b) => !b.hidden && b.getClientRects().length);
    let i = list.indexOf(r);
    i = dir === 'h' ? 0 : dir === 'e' ? list.length - 1 : (i + dir + list.length) % list.length;
    const sel = list[i].getAttribute('data-set');
    list[i].focus();
    list[i].click();
    /* falls die Gruppe neu aufgebaut wurde */
    const again = g.querySelector('[data-set="' + sel + '"]');
    if (again && d.activeElement !== again) again.focus();
  });

  /* ------------------------------------------------------------ Crew */
  function activate(i, src) {
    if (i === active || !crew[i]) return;
    const prev = Object.assign({}, st);
    active = i;
    st = Object.assign(pick(crew[i]), { view: 'motiv' });
    render(prev, { src, patch: { c: st.c }, url: true });
  }
  function removeSlot(i) {
    if (crew.length < 2) return;
    const prev = Object.assign({}, st);
    crew.splice(i, 1);
    if (i < active || active >= crew.length) active = Math.max(0, active - (i <= active ? 1 : 0));
    if (active >= crew.length) active = crew.length - 1;
    st = Object.assign(pick(crew[active]), { view: st.view });
    render(prev, { url: true });
  }
  function addCrew(src) {
    if (crew.length >= 3 || !B.offer3for2) return;
    const inCrew = new Set(crew.map((e) => e.c));
    let ci = -1;
    for (let k = 1; k <= B.chars.length; k++) {
      const j = (st.c + k) % B.chars.length;
      if (!B.chars[j].x && !inCrew.has(j)) { ci = j; break; }
    }
    if (ci < 0) return;
    const prev = Object.assign({}, st);
    const wn = B.chars[st.c].w[st.w];
    const e = Object.assign(pick(st), { c: ci, w: Math.max(0, B.chars[ci].w.indexOf(wn)), du: 0 });
    crew.push(e);
    active = crew.length - 1;
    st = Object.assign(pick(e), { view: 'motiv' });
    render(prev, { src, patch: { c: ci }, url: true });
  }
  function takeCrew(src) {
    const prev = Object.assign({}, st);
    crew = CREW_DEF.map((sl) => {
      const ci = B.chars.findIndex((c) => c.s === sl);
      const e = { c: ci, w: 0, s: st.s, n: st.n, m: st.m, g: st.g };
      I.norm(e);
      return e;
    });
    active = 0;
    st = Object.assign(pick(crew[0]), { view: 'motiv' });
    render(prev, { src, patch: { c: st.c }, url: true });
    setTimeout(() => scrollToEl($('kaufbox'), MOB.matches ? MINI_H + 12 : 70), 120);
  }

  /* Raumbild-Wand als Crew uebernehmen (Robin 02.11.): tokens im bootCrew-Format slug.welt.stil.name.material.groesse.
     Aktiver Platz = die gerade gewaehlte Figur, falls sie im Bild haengt, sonst die Mitte. Kein addCrew/takeCrew. */
  function takeLook(tokens, src) {
    if (!B.offer3for2 || !tokens || tokens.length < 2 || crew.some((e) => e.du)) return false;
    const prev = Object.assign({}, st);
    const list = tokens.map((x) => {
      const a = x.split('.'), q = new URLSearchParams();
      ['c', 'w', 's', 'n', 'm', 'g'].forEach((k, i) => a[i] && q.set(k, a[i]));
      const e = I.parse(q.toString()); I.norm(e); return e;
    });
    let act = st.du ? -1 : list.findIndex((e) => e.c === st.c);
    if (act < 0) act = Math.min(1, list.length - 1);
    crew = list; active = act;
    st = Object.assign(pick(crew[active]), { view: 'motiv' });
    noteState = ''; /* alter Leinwand-/Name-Hinweis passt nicht mehr zur neuen Wand */
    lastNonCanvas = st.m; lastInFam[R.FAMS[R.famOf(st.m)].f] = st.m;
    render(prev, { src, patch: { c: st.c }, url: true });
    setTimeout(() => scrollToEl($('kaufbox'), MOB.matches ? MINI_H + 12 : 70), 120);
    return true;
  }

  /* ------------------------------------------------------------ Vorladen */
  const pre = new Set();
  function preImg(srcset, sizes) {
    if (!srcset || pre.has(srcset)) return;
    pre.add(srcset);
    const im = new Image(); im.decoding = 'async'; im.sizes = sizes || I.SIZES; im.srcset = srcset;
  }
  function mockSet(s) {
    if (!CAT) return null;
    return [500, 750, 1000].map((w) => mockUrl(s, w) + ' ' + w + 'w').join(', ');
  }
  function preFor(el) {
    const v = el.getAttribute('data-set');
    if (!v) return;
    const [k, val] = v.split(':');
    if (k === 'view') { if (val === 'produkt') preImg(mockSet(st)); return; }
    const s = pick(st);
    if (st.du && k !== 'c') { if (k !== 'fam' && k !== 'g' && k !== 'm') { s[k] = +val; I.norm(s, k); preImg(R.duImg(s, 600) + ' 600w, ' + R.duImg(s, 960) + ' 960w'); } return; }
    s.du = 0;
    if (k === 'fam') { s.m = famMat(val, s.g); I.norm(s, 'm'); preImg(mockSet(s)); return; }
    if (k === 'c') { const wn = B.chars[st.c].w[st.w]; s.c = +val; s.w = Math.max(0, B.chars[s.c].w.indexOf(wn)); }
    else s[k] = +val;
    I.norm(s, k);
    if (k === 'g' || k === 'm') preImg(mockSet(s)); else preImg(I.srcset(s.c, I.di(s)));
  }
  const onPre = (e) => { const el = e.target.closest && e.target.closest('[data-set]'); if (el) preFor(el); };
  d.addEventListener('pointerover', onPre, { passive: true });
  d.addEventListener('pointerdown', onPre, { passive: true });
  d.addEventListener('focusin', onPre);
  const idle = window.requestIdleCallback || ((f) => setTimeout(f, 300));
  /* Im Leerlauf nur die zwei naechsten Charaktere (dort tippen die meisten zuerst), Mockups erst bei Absicht */
  function idlePreload() {
    idle(() => {
      if (st.du) return;
      const wn = B.chars[st.c].w[st.w];
      for (let k = 1; k <= 2; k++) {
        const c = (st.c + k) % B.chars.length, w = Math.max(0, B.chars[c].w.indexOf(wn));
        preImg(I.srcset(c, w * 6 + st.s * 2 + st.n));
      }
    });
  }

  /* ------------------------------------------------------------ Daten nachladen (Mockups und Reviews) */
  function loadCat() {
    const opt = { priority: 'low' };
    fetch((window.IWG_A&&window.IWG_A.cat)||'data/catalog.json', opt).then((r) => r.json()).then((j) => {
      CAT = j; I.CAT = j; catResolve();
      R.update(st, crew, active, { skip: ['price', 'total', 'cta'] });
      updMini();
      renderReviews();
    }).catch(() => {});
  }
  loadCat();
  if (d.readyState === 'complete') setTimeout(idlePreload, 1500); else addEventListener('load', () => setTimeout(idlePreload, 1500));

  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  function chip(r) {
    return '<article class="iwg-review"><i class="tp5 sm" role="img" aria-label="' + r.s + ' von 5 Sternen"></i>' +
      (r.t ? '<b>' + esc(r.t) + '</b>' : '') + '<p>' + esc(r.x) + '</p>' +
      '<footer><span>' + esc(r.n) + '</span><span aria-hidden="true">·</span><span>' + esc(r.m) + '</span>' +
      (r.v ? '<span aria-hidden="true">·</span><span class="vf">Verifiziert</span>' : '') + '</footer></article>';
  }
  function renderReviews() {
    const rv = (CAT && CAT.reviews) || [];
    const half = Math.ceil(rv.length / 2);
    d.querySelectorAll('#reviews .track').forEach((tr, i) => {
      const one = rv.slice(i * half, (i + 1) * half).map(chip).join('');
      tr.innerHTML = '<div class="half">' + one + '</div><div class="half" aria-hidden="true">' + one + '</div>';
    });
    observeAnims();
  }

  /* ------------------------------------------------------------ Sichtbarkeit: Kaufleiste, Header-CTA, Animationen */
  const bar = $('iwg-bar'), hcta = d.querySelector('.h-cta'), buyCta = $('buy-cta');
  const vis = new Set();
  let ctaPast = false;
  const io = new IntersectionObserver((es) => {
    es.forEach((en) => {
      if (en.isIntersecting) vis.add(en.target); else vis.delete(en.target);
      if (en.target === buyCta) ctaPast = !en.isIntersecting && en.boundingClientRect.bottom < 0;
    });
    /* Kaufleiste weg, solange ein anderer Kauf-Knopf im Bild ist (Kaufbox, Crew, Porträt-CTA, Schlusskarte, Footer) */
    bar.classList.toggle('off', vis.size > 0);
    /* Header-CTA erst, wenn der Kaufbox-CTA nach oben weggescrollt ist */
    hcta.classList.toggle('show', ctaPast);
    hcta.tabIndex = ctaPast ? 0 : -1;
    hcta.setAttribute('aria-hidden', ctaPast ? 'false' : 'true');
  });
  [buyCta, $('take-crew'), $('fertig'), $('footer'), d.querySelector('.du-go-box')].forEach((x) => x && io.observe(x));
  const aio = new IntersectionObserver((es) => es.forEach((en) => en.target.classList.toggle('paused', !en.isIntersecting)), { rootMargin: '80px' });
  function observeAnims() { d.querySelectorAll('[data-anim], #reviews .row').forEach((x) => aio.observe(x)); }
  observeAnims();

  /* ------------------------------------------------------------ Neigung (Desktop) */
  /* perspective() steckt im transform selbst: ohne preserve-3d bleibt die Ebene flach, der Hit-Test trifft die Chips */
  const tilt = $('st-tilt');
  col.addEventListener('pointermove', (e) => {
    if (MOB.matches || RM.matches || e.pointerType !== 'mouse') return;
    const r = col.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
    tilt.style.transform = 'perspective(1400px) rotateY(' + (x * 8).toFixed(2) + 'deg) rotateX(' + (-y * 8).toFixed(2) + 'deg)';
  });
  col.addEventListener('pointerleave', () => { tilt.style.transform = ''; });

  /* ------------------------------------------------------------ Debug */
  function lum(hex) {
    const v = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16) / 255).map((c) => (c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)));
    return 0.2126 * v[0] + 0.7152 * v[1] + 0.0722 * v[2];
  }
  function mixHex(a, b, t) {
    return '#' + [1, 3, 5].map((i) => Math.round(parseInt(a.slice(i, i + 2), 16) * t + parseInt(b.slice(i, i + 2), 16) * (1 - t)).toString(16).padStart(2, '0')).join('');
  }
  const cr = (a, b) => { const x = lum(a), y = lum(b); return ((Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05)).toFixed(2); };
  function contrastInfo() {
    const t = I.tok(st), panel = mixHex(t[5], '#ffffff', 0.78);
    return { panelWorst: panel, text: cr('#F5F4F1', panel), muted: cr(mixHex('#F5F4F1', panel, 0.72), panel), hl: cr(t[6], panel), cta: cr('#200C3E', '#EE348C') };
  }
  function debug() {
    let el = $('iwg-debug');
    if (!el) { el = d.createElement('pre'); el.id = 'iwg-debug'; el.className = 'iwg-debug'; d.body.appendChild(el); }
    const t = I.tok(st), tokens = {};
    I.TOK.forEach((k, i) => (tokens[k] = t[i]));
    el.textContent = JSON.stringify({
      state: { c: B.chars[st.c].s, w: B.chars[st.c].w[st.w], s: I.STI[st.s], n: I.NAM[st.n], m: B.mats[st.m].s, g: B.sizes[st.g].s, view: st.view, d: I.di(st) },
      vid: st.du ? 'DU ' + R.duVid(st) : vid(st), crew: crew.map((e) => (e.du ? 'du:' + R.duVid(e) : B.chars[e.c].s + ':' + vid(e))), active, tokens, contrast: contrastInfo(),
      perso: { wer: P.wer, cnt: P.cnt, persons: R.persons(), photos: P.photos.length, nameOk: R.nameOk(), ok: P.ok, price: R.price(st) }
    }, null, 1);
  }

  /* ------------------------------------------------------------ DU ALS CHARAKTER */
  /* Beispiele, Buehnenbilder und Namens-Geometrie stehen nur im Manifest assets/perso/examples.json */
  let pmP = null;
  function loadPM() {
    if (!pmP) {
      pmP = (I.pm || fetch(window.IWG_A.pm, { priority: 'low' }).then((r) => r.json()).then(window.IWG_FIX))
        .then((j) => { I.PM = j; onPM(); return j; })
        .catch(() => { if (st.du) updStage(); return null; }); /* ohne Manifest: Marco-Buehne als Rueckfall */
    }
    return pmP;
  }
  function onPM() {
    R.update(st, crew, active, { skip: ['price', 'total', 'cta'] });
    updMini();
    if (st.du) updStage();
    syncDu();
    buildCards();
  }
  const PH = { ich: 'MARCO', paar: 'LEA & TIM', familie: 'DIE BECKS', freunde: 'DIE JUNGS' };
  const FMT = 'Dieses Format können wir hier nicht öffnen. Nimm bitte JPG, PNG oder WebP.';
  const OKT = 'Foto passt. Du siehst es unten links.';
  const WARN = 'Etwas klein. Es geht, schärfer wird es mit dem Original aus deiner Galerie.';
  const ONE = 'Für „Nur ich“ brauchen wir ein Foto. Behalte eins oder wähl „Wir zwei“.';
  const MAXB = 25 * 1024 * 1024;
  /* Upload in den Warenkorb: ueber 20 MB oder ueber 6000 px lange Seite wird es ein JPEG mit max. 4096 px (Qualitaet 0,92), sonst das Original */
  const UP_MB = 20 * 1024 * 1024, UP_PX = 6000, UP_MAX = 4096;
  /* Dateien per DataTransfer in versteckte Datei-Felder legen. Ohne DataTransfer geht das Feld selbst mit seiner Datei ins Formular. */
  const CAN_DT = (() => {
    try {
      const t = new DataTransfer(), i = d.createElement('input');
      t.items.add(new File(['x'], 'x.txt', { type: 'text/plain' }));
      i.type = 'file'; i.files = t.files;
      return !!(i.files && i.files.length === 1);
    } catch (e) { return false; }
  })();
  const INP = new WeakMap(); /* nur ohne DataTransfer: Datei -> Feld, das sie haelt */
  let fileIn = $('du-file');
  const drop = $('du-drop'), nameIn = $('du-name-in'), okIn = $('du-ok');
  const dn = $('st-dn'), pol = $('st-pol');
  let repl = -1;
  const maxPh = () => (P.wer === 'ich' ? 1 : 3);
  /* "Wer" bewusst gesetzt (Klick oder wer= in der URL): der Abschnitts-CTA ueberschreibt es dann nicht */
  let werPinned = !!new URLSearchParams(location.search).get('wer');
  /* Einwilligung gilt nur fuer die Fotos, die der Kunde bestaetigt hat: neue oder entfernte Fotos setzen sie zurueck */
  function resetOk() { if (P.ok || okIn.checked) { P.ok = false; okIn.checked = false; } }

  function rov(g) {
    const b = Array.from(g.querySelectorAll('[role=radio]'));
    const k = Math.max(0, b.findIndex((x) => x.getAttribute('aria-checked') === 'true'));
    b.forEach((x, i) => { x.tabIndex = i === k ? 0 : -1; });
  }
  function syncDu() {
    d.querySelectorAll('#t-wer [data-wer]').forEach((b) => b.setAttribute('aria-checked', b.getAttribute('data-wer') === P.wer ? 'true' : 'false'));
    rov($('t-wer'));
    $('du-cnt').hidden = !(P.wer === 'familie' || P.wer === 'freunde');
    d.querySelectorAll('#t-cnt [data-cnt]').forEach((b) => b.setAttribute('aria-checked', +b.getAttribute('data-cnt') === P.cnt ? 'true' : 'false'));
    rov($('t-cnt'));
    nameIn.placeholder = PH[P.wer];
    fileIn.multiple = CAN_DT && maxPh() > 1; /* ohne DataTransfer: ein Feld je Foto */
    $('du-name').classList.toggle('on', st.n === 0);
    const multi = $('du-multi');
    multi.hidden = P.wer === 'ich';
    $('du-more').hidden = !P.photos.length || P.photos.length >= maxPh();
    $('du-drop').hidden = P.photos.length > 0;
    const er = $('du-err'), one = P.wer === 'ich' && P.photos.length > 1;
    if (one && er.textContent !== ONE) showErr(ONE); else if (!one && er.textContent === ONE) showErr('');
    updPol();
    updDuName();
  }
  /* kleine Aktualisierung ohne Buehnenwechsel (Tippen im Namensfeld, Foto, Haekchen) */
  function light() {
    R.update(st, crew, active, { skip: ['price', 'total', 'cta'] });
    fill('cta', ctaLabel(R.total(crew)));
    syncDu();
    hideMsg();
  }
  function rerender(src) {
    const prev = Object.assign({}, st);
    crew[active] = pick(st);
    return render(prev, { src, url: true });
  }
  function enterDu(src, ev) {
    loadPM();
    const j = crew.findIndex((e, k) => e.du && k !== active);
    if (j >= 0) activate(j, src);
    else if (!st.du) setState({ c: I.DEF, du: 1 }, src);
    else rerender(src);
    /* aufgeklappten Bereich zeigen, wenn er unter dem Bild liegt */
    if (ev && ev.detail !== 0) {
      setTimeout(() => {
        const pn = $('du-panel'), r = pn.getBoundingClientRect(), top = MOB.matches ? MINI_H + 12 : 80;
        if (r.top > innerHeight * 0.62) scrollTo({ top: r.top + scrollY - Math.max(top, innerHeight * 0.3), behavior: RM.matches ? 'auto' : 'smooth' });
      }, 380);
    }
  }

  /* ---- Foto pruefen: Magic Bytes, 25 MB, EXIF-Drehung, Pixelgrenzen. Alles bleibt im Browser (Object-URL). */
  async function sniff(file) {
    const b = new Uint8Array(await file.slice(0, 16).arrayBuffer());
    const asc = (o, n) => String.fromCharCode.apply(null, Array.from(b.slice(o, o + n)));
    if (b[0] === 0xFF && b[1] === 0xD8 && b[2] === 0xFF) return 'jpg';
    if (b[0] === 0x89 && asc(1, 3) === 'PNG') return 'png';
    if (asc(0, 4) === 'RIFF' && asc(8, 4) === 'WEBP') return 'webp';
    if (asc(4, 4) === 'ftyp' && /^(heic|heix|hevc|hevx|heim|heis|mif1|msf1|avif)$/.test(asc(8, 4))) return 'heic';
    return '';
  }
  function viaImg(file) {
    return new Promise((res, rej) => {
      const u = URL.createObjectURL(file), im = new Image();
      im.onload = () => res({ src: im, w: im.naturalWidth, h: im.naturalHeight, u });
      im.onerror = () => { URL.revokeObjectURL(u); rej(new Error('fmt')); };
      im.src = u;
    });
  }
  async function readPhoto(file) {
    if (file.size > MAXB) return { err: 'Größer als 25 MB. Nimm bitte eine kleinere Version.' };
    let kind = '';
    try { kind = await sniff(file); } catch (e) { kind = ''; }
    if (!kind) return { err: FMT };
    let src = null, w = 0, h = 0, tmp = null;
    try {
      src = await createImageBitmap(file, { imageOrientation: 'from-image' }); w = src.width; h = src.height;
    } catch (e) {
      try { const r = await viaImg(file); src = r.src; w = r.w; h = r.h; tmp = r.u; } catch (e2) { return { err: FMT }; }
    }
    const done = () => { if (src && src.close) src.close(); if (tmp) URL.revokeObjectURL(tmp); };
    if (!w || !h) { done(); return { err: FMT }; }
    if (Math.min(w, h) < 1000) { done(); return { err: 'Für ein scharfes Porträt zu klein. Nimm bitte das Original.' }; }
    const k = Math.min(1, 520 / Math.max(w, h)), cv = d.createElement('canvas');
    cv.width = Math.round(w * k); cv.height = Math.round(h * k);
    cv.getContext('2d').drawImage(src, 0, 0, cv.width, cv.height);
    /* zu gross fuer den Warenkorb oder HEIC/AVIF: als JPEG neu schreiben (src ist schon nach EXIF gedreht), sonst geht das Original mit */
    let up = file;
    const MT = { jpg: 'image/jpeg', png: 'image/png', webp: 'image/webp' }[kind];
    if (CAN_DT && (!MT || file.size > UP_MB || Math.max(w, h) > UP_PX)) {
      try {
        const k2 = Math.min(1, UP_MAX / Math.max(w, h)), c2 = d.createElement('canvas');
        c2.width = Math.round(w * k2); c2.height = Math.round(h * k2);
        c2.getContext('2d').drawImage(src, 0, 0, c2.width, c2.height);
        const b2 = await new Promise((r) => c2.toBlob(r, 'image/jpeg', 0.92));
        c2.width = c2.height = 0;
        if (!b2) throw new Error('blob');
        up = new File([b2], (file.name || 'foto').replace(/\.[^.]*$/, '') + '.jpg', { type: 'image/jpeg', lastModified: Date.now() });
      } catch (e) { done(); return { err: 'Dieses Foto ist zu groß für uns. Nimm bitte eine kleinere Version.' }; }
    } else if (CAN_DT && file.type !== MT) {
      /* Name oder Typ passt nicht zum Inhalt (z. B. JPEG als .HEIC): gleiche Bytes, passender Name und Typ */
      up = new File([file], (file.name || 'foto').replace(/\.[^.]*$/, '') + '.' + kind, { type: MT, lastModified: file.lastModified });
    }
    done();
    const blob = await new Promise((r) => cv.toBlob(r, 'image/jpeg', 0.86));
    return { url: URL.createObjectURL(blob || file), w, h, warn: Math.min(w, h) < 1500, file: up, inp: INP.get(file) || null };
  }
  /* ohne DataTransfer: Feld einer verworfenen oder entfernten Datei wieder weg */
  function dropInp(x) { const i = x && (x.inp || INP.get(x)); if (i && !P.photos.some((p) => p.inp === i)) i.remove(); }
  function showErr(t) { const e = $('du-err'); e.textContent = t; e.hidden = !t; }
  async function handleFiles(files, ri) {
    showErr('');
    let added = 0, err = '', cut = false;
    for (const f of files) {
      if (ri < 0 && P.photos.length >= maxPh()) { cut = true; dropInp(f); break; }
      const r = await readPhoto(f);
      if (r.err) { err = r.err; dropInp(f); continue; }
      if (ri >= 0 && P.photos[ri]) { const old = P.photos[ri]; URL.revokeObjectURL(old.url); P.photos[ri] = r; dropInp(old); ri = -1; }
      else P.photos.push(r);
      added++;
    }
    if (!err && cut) err = maxPh() === 1 ? 'Für „Nur ich“ reicht ein Foto, wir haben das erste genommen.' : 'Bis zu 3 Fotos, wir haben die ersten genommen.';
    if (added) resetOk();
    renderPhotos();
    light();
    if (err) showErr(err);
    if (added) { live.textContent = P.photos.length > 1 ? P.photos.length + ' Fotos hochgeladen.' : OKT; }
  }
  const ICO_OK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>';
  const ICO_W = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 8v5M12 16.5v.5"/><circle cx="12" cy="12" r="9"/></svg>';
  function renderPhotos() {
    $('du-photos').innerHTML = P.photos.map((p, i) => '<li class="du-ph"><span class="pt"><img src="' + p.url + '" alt="' + (P.photos.length > 1 ? 'Dein Foto ' + (i + 1) : 'Dein Foto') + '" width="48" height="62"></span>' +
      '<span class="px"><b class="' + (p.warn ? 'warn' : 'ok') + '">' + (p.warn ? ICO_W + WARN : ICO_OK + OKT) + '</b><small>' + p.w + ' × ' + p.h + ' Pixel</small>' +
      '<span class="pa"><button type="button" data-ph-new="' + i + '">Anderes Foto</button><button type="button" data-ph-del="' + i + '">Entfernen</button></span></span></li>').join('');
  }
  function updPol() {
    const M = I.PM, ex = M && M.byWer && M.byWer[P.wer];
    const urls = P.photos.length ? P.photos.slice(0, 3).map((p) => p.url) : ex ? [IWG_P('assets/perso/') + ex + '_pol.webp'] : [];
    const on = !!(st.du && urls.length);
    pol.hidden = !on;
    if (!on) return;
    const ims = $('pol-ims'), k = urls.join('|');
    if (ims.getAttribute('data-k') !== k) {
      ims.innerHTML = urls.map((u) => '<img src="' + u + '" alt="" width="96" height="106">').join('');
      ims.setAttribute('data-k', k);
    }
  }
  function onFile() {
    const files = Array.from(fileIn.files || []), ri = repl;
    repl = -1;
    if (CAN_DT || !files.length) fileIn.value = '';
    else {
      /* ohne DataTransfer: dieses Feld behaelt die Datei und wandert versteckt ins Kaufformular, ein frisches Feld nimmt seinen Platz ein */
      const keep = fileIn, fresh = d.createElement('input');
      fresh.type = 'file'; fresh.id = keep.id; fresh.className = keep.className; fresh.accept = keep.accept;
      fresh.setAttribute('aria-describedby', keep.getAttribute('aria-describedby') || '');
      keep.replaceWith(fresh);
      keep.removeAttribute('id'); keep.removeAttribute('aria-describedby'); keep.tabIndex = -1; keep.setAttribute('data-keep', '1');
      $('du-form').appendChild(keep);
      files.forEach((f) => INP.set(f, keep));
      fileIn = fresh; fileIn.addEventListener('change', onFile);
    }
    if (files.length) handleFiles(files, ri);
  }
  fileIn.addEventListener('change', onFile);
  /* Ziehen und Ablegen (Desktop) */
  ['dragenter', 'dragover'].forEach((t) => drop.addEventListener(t, (e) => { e.preventDefault(); drop.classList.add('over'); }));
  ['dragleave', 'drop'].forEach((t) => drop.addEventListener(t, (e) => { e.preventDefault(); if (t === 'dragleave' && drop.contains(e.relatedTarget)) return; drop.classList.remove('over'); }));
  drop.addEventListener('drop', (e) => {
    const f = Array.from((e.dataTransfer && e.dataTransfer.files) || []);
    if (!f.length) return;
    if (!CAN_DT) { showErr('Wähl dein Foto bitte über „Foto hochladen“ aus.'); return; } /* abgelegte Dateien koennten wir sonst nicht mitschicken */
    handleFiles(f, -1);
  });
  /* daneben fallengelassene Dateien nie vom Browser oeffnen lassen */
  ['dragover', 'drop'].forEach((t) => addEventListener(t, (e) => { if (st.du && e.dataTransfer && Array.from(e.dataTransfer.types || []).indexOf('Files') >= 0) e.preventDefault(); }));

  /* ---- Name */
  const nameDisp = () => Array.from(P.name).filter((ch) => R.NAME_RE.test(ch)).join('').replace(/\s+/g, ' ').trim().slice(0, 10).toUpperCase();
  nameIn.addEventListener('input', () => {
    P.name = nameIn.value;
    const v = P.name.trim(), bad = v.length > 10 || (v.length > 0 && !R.NAME_RE.test(v));
    $('du-name-err').hidden = !bad;
    nameIn.setAttribute('aria-invalid', bad ? 'true' : 'false');
    const n = $('du-name-n'); n.textContent = v.length + '/10'; n.classList.toggle('over', v.length > 10);
    light();
  });
  nameIn.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); nameIn.blur(); } });
  okIn.addEventListener('change', () => {
    P.ok = okIn.checked;
    if (P.ok) { $('du-ok-err').hidden = true; okIn.closest('.du-chk').classList.remove('bad'); }
    hideMsg();
  });

  /* ---- Live-Name auf der Buehne: gleiche Geometrie wie das echte Poster (A3: Versalhoehe, Grundlinie, Laufweite, Breite) */
  function stageSet() {
    const M = I.PM;
    if (!M || !M.stage) return null;
    const k = M.byWer && M.byWer[P.wer];
    return M.stage[k] || M.stage.marco || null;
  }
  /* Satz wie design.py (A3): Versalhoehe fest, Laufweite 0,24 Versalhoehen von Buchstabe zu Buchstabe,
     jeder Buchstabe seitlich um "bold" verbreitert (drei versetzte Lagen) und um "hscale" um die eigene Mitte gestreckt,
     Luecken bleiben gleich, die Tinte steht mittig, nie breiter als 88 % (Rand 6 %). Zu lange Namen werden kleiner. */
  const ctxN = d.createElement('canvas').getContext('2d');
  function layoutName(txt, S, W, H) {
    const chars = Array.from(txt), nch = Math.max(1, chars.length - 1), mw = S.maxW * W, mg = (1 - S.maxW) / 2 * W;
    ctxN.font = '100px "Bebas Neue"';
    const adv = ctxN.measureText(txt).width / 100;
    const build = (fs) => {
      const cap = FM.cap * fs, r = S.bold * cap, sx = S.hscale || 1, tr = S.track * cap;
      ctxN.font = fs + 'px "Bebas Neue"';
      const L = [];
      let shift = 0;
      chars.forEach((ch, n) => {
        if (ch === ' ') return;
        const pen = ctxN.measureText(chars.slice(0, n).join('')).width + n * tr, m = ctxN.measureText(ch);
        const il = pen - m.actualBoundingBoxLeft, ir = pen + m.actualBoundingBoxRight, w0 = ir - il;
        const extra = (w0 + 2 * r) * sx - w0, tx = shift + extra / 2;
        shift += extra;
        L.push({ ch, pen, c: (il + ir) / 2, tx, half: ((w0 + 2 * r) * sx) / 2 });
      });
      if (!L.length) return null;
      const lo = Math.min.apply(null, L.map((l) => l.c + l.tx - l.half)), hi = Math.max.apply(null, L.map((l) => l.c + l.tx + l.half));
      return { fs, cap, r, sx, L, lo, hi };
    };
    let g = build(Math.min((S.capFrac * H) / FM.cap, mw / (adv + nch * S.track * FM.cap)));
    /* Verbreiterung (bold, hscale) mitrechnen: die fertige Tinte bleibt innerhalb von 88 % */
    if (g && g.hi - g.lo > mw) g = build((g.fs * mw) / (g.hi - g.lo) * 0.995);
    if (!g) return null;
    g.x0 = Math.max(mg - g.lo, Math.min(S.cx * W - (g.lo + g.hi) / 2, W - mg - g.hi));
    return g;
  }
  /* Grundlinie im Zeilenkasten so messen, wie der Browser sie setzt (rundet anders als die Formel) */
  function baseOff(fs) {
    const pb = d.createElement('b'), mk = d.createElement('span');
    pb.style.cssText = 'position:absolute;left:0;top:0;visibility:hidden;line-height:1;font-size:' + fs.toFixed(2) + 'px';
    mk.style.cssText = 'display:inline-block;width:0;height:0;vertical-align:baseline';
    pb.textContent = 'H'; pb.appendChild(mk); dn.appendChild(pb);
    const v = mk.getBoundingClientRect().top - pb.getBoundingClientRect().top;
    pb.remove();
    return v > 0 ? v : fs * ((1 - (FM.a + FM.d)) / 2 + FM.a);
  }
  function updDuName() {
    const S = stageSet(), on = !!(st.du && st.n === 0 && S);
    dn.hidden = !on;
    if (!on) return;
    const W = card.offsetWidth, H = card.offsetHeight;
    if (!W || !H) return;
    const txt = nameDisp() || String(S.text || '').toUpperCase(), g = layoutName(txt, S, W, H);
    if (!g) { dn.innerHTML = ''; return; }
    const base = (typeof S.base === 'object' ? S.base[I.STI[st.s]] : S.base) * H;
    const bo = baseOff(g.fs), f = S.fill[st.w] || S.fill[0];
    const bg = 'linear-gradient(180deg,' + f[0] + ' ' + (bo - g.cap).toFixed(1) + 'px,' + f[1] + ' ' + (bo - g.cap / 2).toFixed(1) + 'px,' + f[2] + ' ' + bo.toFixed(1) + 'px)';
    const top = (base - bo).toFixed(2), fz = g.fs.toFixed(2) + 'px';
    dn.innerHTML = g.L.map((l) => {
      const one = (dx) => '<b style="left:' + dx.toFixed(2) + 'px;background-image:' + bg + '">' + esc(l.ch) + '</b>';
      return '<i style="left:' + (g.x0 + l.pen).toFixed(2) + 'px;top:' + top + 'px;font-size:' + fz + ';transform-origin:' + (l.c - l.pen).toFixed(2) + 'px 0;transform:translateX(' + l.tx.toFixed(2) + 'px) scaleX(' + g.sx + ')">' +
        one(-g.r) + one(0) + one(g.r) + '</i>';
    }).join('');
  }

  /* ---- Kauf im DU-Modus: Kette Foto, Name, Haekchen, dann echtes Formular (multipart) an /cart/add.
     Fotos gehen als Shopify-Datei-Property mit (properties[Foto], [Foto 2], [Foto 3]), der Warenkorb zeigt sie als /uploads/-Link.
     Crew mit Porträt: erst die Charaktere per /cart/add.js, dann das Formular (Shopify leitet danach auf /cart). */
  const ON_SHOP = /icon-walls\.de$/.test(location.hostname);
  const CART_ADD = ON_SHOP ? '/cart/add' : 'https://icon-walls.de/cart/add';
  const TWO = 'Pro Bestellung geht ein Porträt aus deinem Foto. Nimm bitte den zweiten Platz „Du als Charakter“ aus deiner Crew.';
  let crewAdded = '';
  function hideMsg() { d.querySelectorAll('.du-msg').forEach((x) => { x.hidden = true; }); }
  function showMsg(a, t) {
    const inBox = a.id === 'buy-cta' || a.id === 'fin-cta';
    const box = inBox ? a.nextElementSibling : d.querySelector('#kaufbox .du-msg');
    box.textContent = t; box.hidden = false;
    if (!inBox) scrollToEl($('buy-cta'), (MOB.matches ? MINI_H + 12 : 80) + 60);
  }
  function setBusy(on) {
    buying = on;
    d.querySelectorAll('[data-buy]').forEach((b) => { b.classList.toggle('busy', on); if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy'); });
    fill('cta', ctaLabel(R.total(crew)));
  }
  /* zurueck aus dem Warenkorb (bfcache): Knoepfe wieder frei */
  addEventListener('pageshow', (e) => { if (e.persisted && buying) setBusy(false); });
  function duFields(e) {
    const f = $('du-form');
    f.action = CART_ADD;
    Array.from(f.children).forEach((x) => { if (!x.hasAttribute('data-keep')) x.remove(); });
    const add = (n, v) => { const i = d.createElement('input'); i.type = 'hidden'; i.name = n; i.value = String(v); f.appendChild(i); };
    add('id', R.duVid(e));
    add('quantity', 1);
    P.photos.forEach((p, k) => {
      const n = 'properties[Foto' + (k ? ' ' + (k + 1) : '') + ']';
      if (CAN_DT) {
        const i = d.createElement('input'), t = new DataTransfer();
        i.type = 'file'; i.name = n; t.items.add(p.file); i.files = t.files;
        if (!i.files || i.files.length !== 1) throw new Error('foto');
        f.appendChild(i);
      } else {
        if (!p.inp || !p.inp.files || !p.inp.files.length) throw new Error('foto');
        p.inp.name = n; f.appendChild(p.inp);
      }
    });
    add('properties[Wer]', R.WERL[P.wer]);
    add('properties[Personen]', R.persons());
    add('properties[Farbwelt]', R.wnm(e, e.w));
    add('properties[Style]', R.STL[e.s]);
    add('properties[Name im Motiv]', R.NML[e.n]);
    if (e.n === 0) add('properties[Name]', nameDisp());
    add('properties[_Einwilligung]', new Date().toISOString() + ' · ' + d.querySelector('#du-ok-wrap [data-f=okTx]').textContent.trim());
    add('properties[_Quelle]', 'gta-lp');
    return f;
  }
  async function duBuy(a) {
    if (buying) return;
    const di = crew.findIndex((x) => x.du), de = crew[di], off = MOB.matches ? MINI_H + 12 : 80;
    if (!P.photos.length) {
      if (!st.du) activate(di, a);
      fileIn.click();
      setTimeout(() => scrollToEl($('du-up'), off), 60);
      return;
    }
    if (P.wer === 'ich' && P.photos.length > 1) {
      if (!st.du) activate(di, a);
      setTimeout(() => { scrollToEl($('du-up'), off); showErr(ONE); }, 60);
      return;
    }
    if (de.n === 0 && !R.nameOk()) {
      if (!st.du) activate(di, a);
      setTimeout(() => { scrollToEl($('du-name'), off + 40); nameIn.focus({ preventScroll: true }); if (P.name.trim()) $('du-name-err').hidden = false; }, 60);
      return;
    }
    if (!P.ok) {
      $('du-ok-err').hidden = false; okIn.closest('.du-chk').classList.add('bad');
      const r = $('du-ok-wrap').getBoundingClientRect();
      if (r.top < off || r.bottom > innerHeight - 90) scrollToEl($('du-ok-wrap'), off + 20);
      okIn.focus({ preventScroll: true });
      return;
    }
    if (crew.filter((x) => x.du).length > 1) { showMsg(a, TWO); return; }
    hideMsg();
    setBusy(true);
    try {
      const items = crew.filter((x) => !x.du).map((x) => ({ id: vid(x), quantity: 1 }));
      const key = items.map((x) => x.id).join(',');
      if (items.length && !ON_SHOP) console.info('[iwg] Nicht auf icon-walls.de: die Charaktere der Crew legen wir hier nicht per /cart/add.js in den Warenkorb.', key);
      else if (items.length && crewAdded !== key) {
        const r = await fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!r.ok) throw new Error('cart ' + r.status);
        crewAdded = key; /* zweiter Versuch nach einem Fehler legt die Charaktere nicht doppelt hinein */
      }
      duFields(de).submit();
    } catch (err) {
      setBusy(false);
      showMsg(a, 'Das hat gerade nicht geklappt. ' + (P.photos.length > 1 ? 'Deine Fotos' : 'Dein Foto') + ' und deine Angaben sind noch da, versuch es bitte gleich noch einmal.');
    }
  }

  /* ---- Klicks im DU-Bereich (true = erledigt) */
  function duClick(t, e) {
    if (t.closest('#tdu')) { enterDu(t.closest('#tdu'), e); return true; }
    const wb = t.closest('[data-wer]');
    if (wb && wb.closest('#t-wer')) { const v = wb.getAttribute('data-wer'); werPinned = true; if (v !== P.wer) { P.wer = v; showErr(''); rerender(); } return true; }
    const cb = t.closest('[data-cnt]');
    if (cb) { const v = +cb.getAttribute('data-cnt'); if (v !== P.cnt) { P.cnt = v; rerender(); } return true; }
    const nb = t.closest('[data-ph-new]');
    if (nb) { repl = +nb.getAttribute('data-ph-new'); fileIn.multiple = false; fileIn.click(); return true; }
    const xb = t.closest('[data-ph-del]');
    if (xb) {
      const i = +xb.getAttribute('data-ph-del'), ph = P.photos[i];
      if (ph) URL.revokeObjectURL(ph.url);
      P.photos.splice(i, 1); dropInp(ph); resetOk(); renderPhotos(); showErr(''); light();
      const f = P.photos.length ? d.querySelector('[data-ph-new="0"]') : fileIn;
      if (f) f.focus({ preventScroll: true });
      live.textContent = 'Foto entfernt.';
      return true;
    }
    if (t.closest('#du-more')) { repl = -1; fileIn.multiple = CAN_DT; fileIn.click(); return true; }
    if (t.closest('.st-dlink')) { e.preventDefault(); scrollToEl($('du-als-charakter'), MOB.matches ? MINI_H + 4 : 64); return true; }
    if (t.closest('#du-go')) {
      /* Wer der zuletzt angesehenen Karte nur, solange der Kunde noch nichts eingegeben hat */
      const ex = (I.PM && I.PM.examples) || [], x = cardSeen ? ex[lastCard] || null : null;
      const busy = werPinned || P.photos.length > 0 || P.name.trim() !== '';
      if (x && !busy) { P.wer = x.wer; if (x.wer === 'familie' || x.wer === 'freunde') P.cnt = x.persons >= 4 ? 4 : 3; }
      enterDu(null, null);
      setTimeout(() => scrollToEl($('stufe-1'), MOB.matches ? MINI_H + 12 : 70), 60);
      return true;
    }
    const dot = t.closest('[data-dot]');
    if (dot) { const c = cardsEl.children[+dot.getAttribute('data-dot')]; if (c) cardsEl.scrollTo({ left: c.offsetLeft - (cardsEl.clientWidth - c.offsetWidth) / 2, behavior: RM.matches ? 'auto' : 'smooth' }); return true; }
    return false;
  }

  /* ---- Abschnitt: Vorher-Nachher-Karten aus dem Manifest */
  const cardsEl = $('du-cards'), dotsEl = $('du-dots');
  let cardsBuilt = false, lastCard = 0, cardSeen = false;
  const ARR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9.5 7 4.5 12l5 5M14.5 7l5 5-5 5"/></svg>';
  function cardHTML(x, i) {
    const nm = (x.name ? 'Mit Name ' + x.name : 'Ohne Name').replace(/ /g, '\u00a0'), wl = R.WERL[x.wer] + (x.persons > 2 ? ' · ' + x.persons + ' Personen' : '');
    return '<article class="du-card" role="listitem" data-i="' + i + '">' +
      '<div class="ba" style="--p:50%">' +
      '<img class="ba-n" src="' + esc(x.img.nachher) + '" alt="' + esc(x.alt) + '" width="720" height="960" loading="lazy" decoding="async">' +
      '<div class="ba-v"><img src="' + esc(x.img.vorher) + '" alt="" width="720" height="960" loading="lazy" decoding="async"></div>' +
      '<span class="ba-t l" aria-hidden="true">Vorher</span><span class="ba-t r" aria-hidden="true">Nachher</span>' +
      (x.placeholder ? '<span class="ba-ph" aria-hidden="true">Bild folgt</span>' : '') +
      '<span class="ba-l" aria-hidden="true"></span>' +
      '<div class="ba-h" role="slider" tabindex="0" aria-label="Vorher und Nachher vergleichen: ' + esc(x.who) + '" aria-valuemin="0" aria-valuemax="100" aria-valuenow="50" aria-valuetext="50 Prozent Vorher"><i>' + ARR + '</i></div>' +
      '</div>' +
      '<div class="du-cap"><p class="who"><b>' + esc(x.who) + '</b><span>' + esc(wl) + '</span></p>' +
      '<p class="cfg">' + esc([x.welt, x.stil, nm].join(' · ')) + '</p><p class="mat">' + esc(x.material) + '</p>' +
      '</div></article>';
  }
  function buildCards() {
    if (cardsBuilt || !I.PM || !cardsEl) return;
    cardsBuilt = true;
    const ex = I.PM.examples || [];
    cardsEl.innerHTML = ex.map(cardHTML).join('');
    dotsEl.innerHTML = ex.map((x, i) => '<button type="button" data-dot="' + i + '" aria-label="Beispiel ' + (i + 1) + ' von ' + ex.length + ': ' + esc(x.who) + '"' + (i === 0 ? ' aria-current="true"' : '') + '></button>').join('');
    Array.from(cardsEl.children).forEach((c, i) => wireBA(c.querySelector('.ba'), i));
    const cio = new IntersectionObserver((es) => es.forEach((en) => {
      const i = +en.target.getAttribute('data-i');
      if (en.isIntersecting && en.intersectionRatio >= 0.6) {
        if (MOB.matches) { lastCard = i; cardSeen = true; dotsEl.querySelectorAll('button').forEach((b, k) => b.setAttribute('aria-current', k === i ? 'true' : 'false')); }
        hint(en.target.querySelector('.ba'));
      }
    }), { root: MOB.matches ? cardsEl : null, threshold: [0, 0.6] });
    Array.from(cardsEl.children).forEach((c) => cio.observe(c));
  }
  function wireBA(ba, idx) {
    const hd = ba.querySelector('.ba-h');
    let drag = false, raf = 0;
    const setP = (p, user) => {
      p = Math.max(0, Math.min(100, p));
      ba.style.setProperty('--p', p.toFixed(2) + '%');
      ba.classList.toggle('lo', p < 14); ba.classList.toggle('hi', p > 86);
      hd.setAttribute('aria-valuenow', String(Math.round(p)));
      hd.setAttribute('aria-valuetext', Math.round(p) + ' Prozent Vorher');
      ba._p = p;
      if (user) { ba._u = 1; cancelAnimationFrame(raf); lastCard = idx; cardSeen = true; }
    };
    ba._set = setP; ba._p = 50;
    const fromX = (x) => { const r = ba.getBoundingClientRect(); return ((x - r.left) / r.width) * 100; };
    const tween = (to) => {
      cancelAnimationFrame(raf);
      const p0 = ba._p, t0 = performance.now(), dur = RM.matches ? 0 : 320;
      const step = (now) => { const k = dur ? Math.min(1, (now - t0) / dur) : 1, e = 1 - Math.pow(1 - k, 3); setP(p0 + (to - p0) * e); if (k < 1) raf = requestAnimationFrame(step); };
      raf = requestAnimationFrame(step);
    };
    ba._tween = tween;
    let pend = null;
    ba.addEventListener('pointerdown', (e) => {
      const onH = !!e.target.closest('.ba-h');
      ba._pt = e.pointerType;
      /* Touch: nur der Griff zieht, Wischen auf dem Bild blaettert weiter. Maus: ueberall ziehen. */
      if (e.pointerType === 'touch') return; /* Touch laeuft ueber die Touch-Events unten (Safari bricht Pointer-Drags sonst ab) */
      if ((e.pointerType !== 'mouse' && !onH) || e.button > 0) return;
      if (e.pointerType !== 'mouse') { pend = { x: e.clientX, y: e.clientY }; return; } /* Richtung abwarten */
      drag = true; ba.classList.add('drag');
      try { ba.setPointerCapture(e.pointerId); } catch (x) { /* egal */ }
      setP(fromX(e.clientX), true);
      e.preventDefault();
    });
    ba.addEventListener('pointermove', (e) => {
      if (pend) {
        const dx = Math.abs(e.clientX - pend.x), dy = Math.abs(e.clientY - pend.y);
        if (dy > 6 && dy >= dx) { pend = null; return; }
        if (dx < 5 || dx < dy) return;
        pend = null; drag = true; ba.classList.add('drag');
        try { ba.setPointerCapture(e.pointerId); } catch (x) { /* egal */ }
      }
      if (drag) setP(fromX(e.clientX), true);
    });
    const end = () => { pend = null; drag = false; ba.classList.remove('drag'); };
    /* Handy: Griff mit Richtungs-Sperre. Waagrecht los = die ganze Geste gehoert dem Regler (kein Abbruch durch
       Karten-Wischen oder Seiten-Scroll), senkrecht los = die Seite scrollt normal. */
    const hdl = ba.querySelector('.ba-h');
    let tch = null;
    if (hdl) {
      hdl.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) { tch = null; return; }
        const t = e.touches[0]; tch = { x: t.clientX, y: t.clientY, lock: '' };
      }, { passive: true });
      hdl.addEventListener('touchmove', (e) => {
        if (!tch || e.touches.length !== 1) return;
        const t = e.touches[0], dx = t.clientX - tch.x, dy = t.clientY - tch.y;
        if (!tch.lock) {
          if (Math.abs(dx) < 4 && Math.abs(dy) < 4) return;
          tch.lock = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
          if (tch.lock === 'x') { drag = true; ba.classList.add('drag'); ba._u = 1; lastCard = idx; cardSeen = true; }
        }
        if (tch.lock !== 'x') return;
        if (e.cancelable) e.preventDefault();
        setP(fromX(t.clientX), true);
      }, { passive: false });
      const tend = () => { if (tch && tch.lock === 'x') end(); tch = null; };
      hdl.addEventListener('touchend', tend);
      hdl.addEventListener('touchcancel', tend);
    }
    /* lostpointercapture nur vom Bild selbst: beim Umhaengen der Touch-Capture vom Griff aufs Bild meldet der Griff sie auch */
    ba.addEventListener('pointerup', end); ba.addEventListener('pointercancel', end); ba.addEventListener('lostpointercapture', (e) => { if (e.target === ba) end(); });
    /* Tippen auf das Bild setzt den Regler dorthin */
    ba.addEventListener('click', (e) => {
      if (ba._pt === 'mouse' || e.target.closest('.ba-h')) return;
      ba._u = 1; lastCard = idx; cardSeen = true; tween(Math.max(0, Math.min(100, fromX(e.clientX))));
    });
    hd.addEventListener('keydown', (e) => {
      const k = e.key, big = 20, sm = 5;
      let to = null;
      if (k === 'ArrowLeft' || k === 'ArrowDown') to = ba._p - sm;
      else if (k === 'ArrowRight' || k === 'ArrowUp') to = ba._p + sm;
      else if (k === 'PageDown') to = ba._p - big;
      else if (k === 'PageUp') to = ba._p + big;
      else if (k === 'Home') to = 0;
      else if (k === 'End') to = 100;
      if (to === null) return;
      e.preventDefault(); setP(to, true);
    });
    ['pointerenter', 'focusin'].forEach((t) => ba.closest('.du-card').addEventListener(t, () => { if (!MOB.matches) { lastCard = idx; cardSeen = true; } }));
  }
  /* einmaliger Hinweis: Regler wandert kurz hin und her, sobald die Karte im Bild ist */
  function hint(ba) {
    if (!ba || ba._h || ba._u || RM.matches) return;
    ba._h = 1;
    const seq = [[50, 30, 420], [30, 66, 620], [66, 50, 420]];
    let i = 0;
    const run = () => {
      if (ba._u || i >= seq.length) return;
      const [a, b, dur] = seq[i++], t0 = performance.now();
      const step = (now) => {
        if (ba._u) return;
        const k = Math.min(1, (now - t0) / dur), e = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
        ba._set(a + (b - a) * e);
        if (k < 1) requestAnimationFrame(step); else run();
      };
      requestAnimationFrame(step);
    };
    setTimeout(run, 350);
  }
  /* Manifest laden: sofort im DU-Modus, sonst sobald der Abschnitt naht oder im Leerlauf */
  if (st.du || crew.some((e) => e.du)) loadPM();
  const sio = new IntersectionObserver((es) => { if (es.some((en) => en.isIntersecting)) { loadPM(); sio.disconnect(); } }, { rootMargin: '1200px 0px' });
  if ($('du-als-charakter')) sio.observe($('du-als-charakter'));
  addEventListener('load', () => setTimeout(() => idle(loadPM), 2500));
  d.addEventListener('pointerover', (e) => { if (e.target.closest && e.target.closest('#tdu')) loadPM(); }, { passive: true });

  /* ------------------------------------------------------------ Start */
  nameSp[0].textContent = curBg;
  fitName(nameSp[0]);
  if (d.fonts && d.fonts.ready) d.fonts.ready.then(refit);
  /* Bebas kommt oft erst nach fonts.ready: dann neu messen, sonst steht der Live-Name in der Breite der Ersatzschrift */
  if (d.fonts && d.fonts.addEventListener) d.fonts.addEventListener('loadingdone', refit);
  addEventListener('resize', refit);
  imgs[0].classList.add('on');
  if (crew.length > 1) { R.update(st, crew, active); shownTotal = R.total(crew); }
  revealSel(true);
  updMini();
  updNote();
  onScroll();
  if (DEBUG) debug();
  syncDu();
  window.__iwgApi = { get state() { return Object.assign({}, st); }, get crew() { return crew.map((e) => Object.assign({}, e)); }, get active() { return active; },
    vid, setState, takeLook, get ready() { return !!CAT; },
    get perso() { return { wer: P.wer, cnt: P.cnt, photos: P.photos.length, name: P.name, ok: P.ok, pm: !!I.PM, fm: FM }; } };
})();

/* Raumbeispiele (Robin 02.11.): Wand-Streifen mit Crew-Knopf (unter dem Warenkorb-Knopf), Größen-Beleg in Stufe 4, Crew-Foto,
   Galerie bei "Was passt an deine Wand?", Großansicht als natives dialog. Bilder vom Shopify-CDN, sie laden erst
   kurz bevor sie ins Bild scrollen; das Bühnenbild bleibt das LCP.
   ?raeume=0 blendet alles aus (Vergleich vorher/nachher). */
(() => {
  const ROOMS = {"raum-01_crew_yeezy":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-raum-01_crew_yeezy.jpg?v=1793645185","alt":"Raumbeispiel: Gaming-Zimmer bei Tag, Yeezys im Regal: 3 gerahmte GTA-VI-Poster (Boobie, Jason (Bandana) und Real Dimez) an der Wand","g":"45x60","p":[["boobie","original","palmen","ohne"],["jason-bandana","original","palmen","ohne"],["real-dimez","original","palmen","ohne"]]},"raum-02_sofa_jordans":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-raum-02_sofa_jordans.jpg?v=1793645189","alt":"Raumbeispiel: Wohnzimmer mit grünem Sofa und Jordans: 3 gerahmte GTA-VI-Poster (Cal, Raul und Brian) an der Wand","g":"45x60","p":[["cal","original","skyline","ohne"],["raul","original","skyline","ohne"],["brian","original","skyline","ohne"]]},"raum-03_sneakerregal":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-raum-03_sneakerregal.jpg?v=1793645195","alt":"Raumbeispiel: Schreibtisch neben Sneaker-Regal: 2 gerahmte GTA-VI-Poster (Raul und Jason (Bandana)) an der Wand","g":"45x60","p":[["raul","ocean","palmen","ohne"],["jason-bandana","ocean","palmen","ohne"]]},"raum-04_magenta_detail":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-raum-04_magenta_detail.jpg?v=1793645200","alt":"Raumbeispiel: Magenta-LED über dem Monitor: ein gerahmtes GTA-VI-Poster (Real Dimez) an der Wand","g":"45x60","p":[["real-dimez","original","skyline","ohne"]]},"raum-05_sideboard_ps5":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-raum-05_sideboard_ps5.jpg?v=1793645203","alt":"Raumbeispiel: Sideboard mit PS5 und Jordans: ein gerahmtes GTA-VI-Poster (Brian) an der Wand","g":"60x80","p":[["brian","original","palmen","ohne"]]},"raum-06_nacht_nanoleaf":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-raum-06_nacht_nanoleaf.jpg?v=1793645207","alt":"Raumbeispiel: Setup bei Nacht mit Nanoleaf: ein gerahmtes GTA-VI-Poster (Jason (Bandana)) an der Wand","g":"60x80","p":[["jason-bandana","neon-night","skyline","mit"]]},"raum-07_nacht_crew":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-raum-07_nacht_crew.jpg?v=1793645211","alt":"Raumbeispiel: Nacht-Setup mit Crew an der Wand: 3 gerahmte GTA-VI-Poster (Dre'Quan, Jason (Bandana) und Cal) an der Wand","g":"30x40","p":[["drequan","neon-night","skyline","mit"],["jason-bandana","neon-night","skyline","mit"],["cal","neon-night","skyline","mit"]]},"raum-08_bett_lila":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-raum-08_bett_lila.jpg?v=1793645216","alt":"Raumbeispiel: Schlafzimmer mit lila LED: 2 gerahmte GTA-VI-Poster (Boobie und Real Dimez) an der Wand","g":"30x40","p":[["boobie","sunset","palmen","mit"],["real-dimez","neon-night","palmen","mit"]]},"raum-09_bett_blau":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-raum-09_bett_blau.jpg?v=1793645222","alt":"Raumbeispiel: Schlafzimmer mit blauer LED: 3 gerahmte GTA-VI-Poster (Boobie, Real Dimez und Brian) an der Wand","g":"45x60","p":[["boobie","ocean","skyline","ohne"],["real-dimez","lavender","skyline","ohne"],["brian","ocean","skyline","ohne"]]},"raum-10_dach_sneaker":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-raum-10_dach_sneaker.jpg?v=1793645228","alt":"Raumbeispiel: Dachzimmer mit Sneaker-Reihe: ein gerahmtes GTA-VI-Poster (Dre'Quan) an der Wand","g":"45x60","p":[["drequan","original","pur","mit"]]},"gamer-01_zwei_gamer_coop":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-gamer-01_zwei_gamer_coop.jpg?v=1793645232","alt":"Raumbeispiel: Zwei Gamer an zwei Setups im Koop: 3 gerahmte GTA-VI-Poster (Dre'Quan, Jason (Bandana) und Cal) an der Wand","g":"45x60","p":[["drequan","original","palmen","mit"],["jason-bandana","original","palmen","mit"],["cal","original","palmen","mit"]]},"gamer-02_paar_sofa":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-gamer-02_paar_sofa.jpg?v=1793645238","alt":"Raumbeispiel: Paar zockt zusammen auf dem Sofa: 2 gerahmte GTA-VI-Poster (Boobie und Real Dimez) an der Wand","g":"45x60","p":[["boobie","original","palmen","ohne"],["real-dimez","lavender","palmen","ohne"]]},"gamer-03_freunde_bett":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-gamer-03_freunde_bett.jpg?v=1793645242","alt":"Raumbeispiel: Zwei Freunde zocken im Schlafzimmer: 2 gerahmte GTA-VI-Poster (Boobie und Dre'Quan) an der Wand","g":"45x60","p":[["boobie","sunset","skyline","ohne"],["drequan","sunset","skyline","ohne"]]},"gamer-04_sofa_tv":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-gamer-04_sofa_tv.jpg?v=1793645248","alt":"Raumbeispiel: Gamer auf dem Sofa vor dem TV: 3 gerahmte GTA-VI-Poster (Raul, Jason (Bandana) und Brian) an der Wand","g":"45x60","p":[["raul","ocean","skyline","ohne"],["jason-bandana","ocean","skyline","ohne"],["brian","ocean","skyline","ohne"]]},"gamer-05_boden_konsole":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-gamer-05_boden_konsole.jpg?v=1793645253","alt":"Raumbeispiel: Gamer auf dem Teppich vor der Konsole: ein gerahmtes GTA-VI-Poster (Jason (Bandana)) an der Wand","g":"60x80","p":[["jason-bandana","original","palmen","ohne"]]},"gamer-06_sneakerraum":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-gamer-06_sneakerraum.jpg?v=1793645258","alt":"Raumbeispiel: Gamer im Sneaker-Zimmer, Icon-Walls-Seite auf dem Monitor: 2 gerahmte GTA-VI-Poster (Cal und Raul) an der Wand","g":"45x60","p":[["cal","sunset","palmen","mit"],["raul","ocean","palmen","mit"]]},"gamer-07_gamerin":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-gamer-07_gamerin.jpg?v=1793645262","alt":"Raumbeispiel: Gamerin an ihrem Setup: 2 gerahmte GTA-VI-Poster (Real Dimez und Boobie) an der Wand","g":"45x60","p":[["real-dimez","original","palmen","ohne"],["boobie","sunset","palmen","mit"]]},"gamer-08_streamer":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-gamer-08_streamer.jpg?v=1793645268","alt":"Raumbeispiel: Streamer vor seiner Wand: 3 gerahmte GTA-VI-Poster (Real Dimez, Jason (Bandana) und Dre'Quan) an der Wand","g":"30x40","p":[["real-dimez","neon-night","skyline","ohne"],["jason-bandana","neon-night","skyline","ohne"],["drequan","neon-night","skyline","ohne"]]},"gamer-09_nacht_ultrawide":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-gamer-09_nacht_ultrawide.jpg?v=1793645272","alt":"Raumbeispiel: Ultrawide-Setup bei Nacht: ein gerahmtes GTA-VI-Poster (Brian) an der Wand","g":"60x80","p":[["brian","ocean","skyline","mit"]]},"gamer-10_nacht_silhouette":{"u":"https://cdn.shopify.com/s/files/1/0972/8252/3464/files/iw-gta-lp-gamer-10_nacht_silhouette.jpg?v=1793645276","alt":"Raumbeispiel: Nacht-Silhouette vor drei Postern: 3 gerahmte GTA-VI-Poster (Cal, Raul und Brian) an der Wand","g":"30x40","p":[["cal","neon-night","skyline","mit"],["raul","neon-night","skyline","ohne"],["brian","neon-night","skyline","mit"]]}};
  const d = document, h = d.documentElement, I = window.__iwg, api = window.__iwgApi;
  if (!I || !api || !I.R) return;
  if (new URLSearchParams(location.search).get('raeume') === '0') { h.classList.add('no-rooms'); return; }
  const B = I.B, R = I.R, $ = (id) => d.getElementById(id);
  const MOB = matchMedia('(max-width: 899px)'), RM = matchMedia('(prefers-reduced-motion: reduce)');
  const NB = ' ';
  const WN = { original: 'Original', 'neon-night': 'Neon Night', sunset: 'Sunset', ocean: 'Ocean', lavender: 'Lavender' };
  const SN = { pur: 'Pur', palmen: 'Palmen', skyline: 'Skyline' };
  const MAT = 'poster-classic-halbmatt';
  const ci = (slug) => B.chars.findIndex((c) => c.s === slug);
  const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const uniq = (a) => a.filter((x, i) => a.indexOf(x) === i);
  const size = (g) => g.replace('x', NB + '×' + NB) + NB + 'cm';
  const names = (r, sep) => r.p.map((p) => R.cname(ci(p[0]))).join(sep || ' · ');
  function spec(r) {
    const nm = uniq(r.p.map((p) => p[3]));
    return [uniq(r.p.map((p) => WN[p[1]])).join(' und '), uniq(r.p.map((p) => SN[p[2]])).join(' und '),
      nm.length > 1 ? 'teils mit Name' : (nm[0] === 'mit' ? 'mit Name' : 'ohne Name'),
      (r.p.length > 1 ? 'je ' : '') + size(r.g)].join(' · ');
  }
  /* Dreier-Wände bekommen den Crew-Knopf, immer in der Größe, die im Bild zu sehen ist (Preis passt so zu Bild und Korb) */
  const tokens = (r) => r.p.map((p) => [p[0], p[1], p[2], p[3], MAT, r.g].join('.'));
  const lookList = (r) => tokens(r).map((x) => { const a = x.split('.'), q = new URLSearchParams();
    ['c', 'w', 's', 'n', 'm', 'g'].forEach((k, i) => q.set(k, a[i])); const e = I.parse(q.toString()); I.norm(e); return e; });
  const canLook = (r) => !!B.offer3for2 && r.p.length === 3;
  const lookBtn = (r) => 'DIESE WAND WÄHLEN · ' + R.eur(R.total(lookList(r)));
  const lookAria = (r) => 'Diese Wand wählen: ' + names(r, ', ') + ', ' + spec(r) + ', zusammen ' + R.eur(R.total(lookList(r)));
  const ev = (n, p) => { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(n, p); } catch (e) {} };

  /* ---------------- Laden: src erst setzen, wenn das Bild gebraucht wird */
  const srcset = (u, ws) => ws.map((w) => u + '&width=' + w + ' ' + w + 'w').join(', ');
  function load(img) {
    if (!img || img.getAttribute('src')) return;
    const r = ROOMS[img.getAttribute('data-room')]; if (!r) return;
    const ws = (img.getAttribute('data-w') || '360,540,720').split(',').map(Number);
    img.sizes = img.getAttribute('data-sizes') || '250px';
    img.addEventListener('load', () => img.classList.add('ld'), { once: true });
    img.srcset = srcset(r.u, ws); img.src = r.u + '&width=' + ws[ws.length - 1];
    if (!img.alt) img.alt = r.alt;
  }
  /* rootMargin wirkt nicht im seitlichen Scroller: mit einem sichtbaren Kartenbild gleich die nächsten zwei laden, beim Wischen nachziehen */
  function near(img) {
    const box = img.closest('.wall-cards'); if (!box) return;
    const all = Array.from(box.querySelectorAll('img[data-room]')), i = all.indexOf(img);
    all.slice(i + 1, i + 3).forEach(load);
  }
  const lio = 'IntersectionObserver' in window
    ? new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { load(en.target); near(en.target); lio.unobserve(en.target); } }), { rootMargin: '300px' })
    : null;
  d.querySelectorAll('.wall-cards').forEach((box) => box.addEventListener('scroll', () => {
    const lim = box.scrollLeft + box.clientWidth * 2;
    box.querySelectorAll('img[data-room]').forEach((img) => { if (img.closest('.wall-card').offsetLeft < lim) load(img); });
  }, { passive: true }));
  const watch = (img) => (lio ? lio.observe(img) : load(img));

  /* ---------------- Karten bauen */
  function card(key, withLook) {
    const r = ROOMS[key]; if (!r) return '';
    const look = withLook && canLook(r);
    return '<div class="wall-card' + (look ? '' : ' no-look') + '">' +
      '<button type="button" class="room-btn" data-lb="' + key + '" aria-label="Raumbeispiel groß ansehen: ' + esc(names(r, ', ')) + '">' +
      '<img data-room="' + key + '" data-w="360,540,720" data-sizes="(max-width:899px) 62vw, 250px" alt="' + esc(r.alt) + '" width="1728" height="2160" decoding="async">' +
      '<span class="room-chip">RAUMBEISPIEL</span></button>' +
      '<div class="wall-cap"><b>' + esc(names(r)) + '</b><span>' + esc(spec(r)) + '</span></div>' +
      (look ? '<button type="button" class="iwg-cta wall-look" data-look="' + key + '" aria-label="' + esc(lookAria(r)) + '"><span>' + esc(lookBtn(r)) + '</span></button>' : '') +
      '</div>';
  }
  function thumb(key) {
    const r = ROOMS[key]; if (!r) return '';
    return '<button type="button" class="size-th" data-lb="' + key + '" aria-label="' + esc('Raumbeispiel ' + size(r.g) + ' groß ansehen') + '">' +
      '<span class="room-btn"><img data-room="' + key + '" data-w="200,300" data-sizes="96px" alt="' + esc(r.alt) + '" width="1728" height="2160" decoding="async">' +
      '<span class="zoom-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="6"/><path d="M15 15l5 5M10.5 8v5M8 10.5h5"/></svg></span></span>' +
      '<span class="size-l">' + size(r.g).replace(NB + 'cm', '') + '</span></button>';
  }
  d.querySelectorAll('[data-rooms]').forEach((box) => {
    const keys = box.getAttribute('data-rooms').split(',');
    box.innerHTML = box.id === 'size-ex-row' ? keys.map(thumb).join('') : keys.map((k) => card(k, box.hasAttribute('data-looks'))).join('');
  });
  /* Unterzeile des Streifens aus den echten Preisen der kleinsten Wand */
  const first = ROOMS['gamer-10_nacht_silhouette'], sub = $('walls-sub');
  if (first && sub && canLook(first)) {
    const l = lookList(first);
    sub.textContent = '3 gerahmte Poster, das günstigste geht aufs Haus. In ' + size(first.g) + ': einzeln ' + R.eur(l.map(R.price).reduce((x, y) => x + y, 0)) + ', zusammen ' + R.eur(R.total(l)) + '.';
  }
  /* alle Bilder laden erst kurz bevor sie ins Bild scrollen (der Streifen steht seit Robins Wunsch unter dem Warenkorb-Knopf) */
  d.querySelectorAll('img[data-room]').forEach(watch);

  /* ---------------- Großansicht */
  const dlg = $('iwg-lb'), lbImg = $('lb-img'), lbPick = $('lb-pick'), lbLook = $('lb-look');
  let lbKey = null, pushed = false, pending = null, pendT = 0, backing = false;
  function openLB(key, src) {
    const r = ROOMS[key]; if (!r || !dlg) return;
    lbKey = key;
    /* sofort das schon geladene Kartenbild zeigen, dann auf die scharfe Fassung tauschen */
    const big = r.u + '&width=' + (MOB.matches ? 1080 : 1440), small = src && src.querySelector && src.querySelector('img');
    lbImg.removeAttribute('src'); lbImg.style.opacity = '0';
    lbImg.onload = () => { lbImg.style.opacity = ''; };
    lbImg.src = (small && small.complete && small.naturalWidth && small.currentSrc) || big; lbImg.alt = r.alt;
    if (lbImg.src !== big) { const pre = new Image(); pre.onload = () => { if (lbKey === key) lbImg.src = big; }; pre.src = big; }
    $('lb-t').textContent = names(r);
    $('lb-s').textContent = spec(r) + ' · im Metallrahmen';
    lbPick.innerHTML = '<span>Motiv übernehmen:</span>' + r.p.map((p, i) => '<button type="button" data-pick="' + i + '">' + esc(R.cname(ci(p[0]))) + '</button>').join('');
    const look = canLook(r) && !!src && !!src.closest('#wall-cards');
    lbLook.hidden = !look;
    if (look) { lbLook.setAttribute('data-look', key); lbLook.firstElementChild.textContent = lookBtn(r); }
    if (dlg.showModal) { try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); h.classList.add('lb-fb'); } }
    else { dlg.setAttribute('open', ''); h.classList.add('lb-fb'); }
    h.classList.add('lb-open');
    /* eigener Verlaufseintrag: die Zurück-Taste (Android, In-App-Browser) schließt nur die Großansicht statt die Seite */
    if (!pushed) { try { history.pushState(Object.assign({}, history.state, { iwgLb: 1 }), ''); pushed = true; } catch (e) {} }
    ev('iwg_room_open', { room: key });
  }
  function shut() {
    if (!dlg || !dlg.hasAttribute('open')) return;
    if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
    h.classList.remove('lb-open', 'lb-fb');
  }
  function settle() { /* Großansicht ist zu, Verlauf ist zurück: jetzt erst die Auswahl ausführen (writeURL schreibt so in den richtigen Eintrag) */
    clearTimeout(pendT); pushed = false; backing = false; shut();
    const p = pending; pending = null; if (p) p();
  }
  /* then: läuft nach dem Schließen, z. B. Motiv übernehmen oder Wand wählen */
  function closeLB(then) {
    if (then) pending = then;
    if (backing) return; /* Zurück läuft schon: kein zweites history.back(), sonst verlässt man die Seite */
    if (pushed && history.state && history.state.iwgLb) {
      backing = true;
      history.back();
      pendT = setTimeout(settle, 800); /* falls popstate ausbleibt */
    } else settle();
  }
  addEventListener('popstate', () => { if (pushed) settle(); });
  if (dlg) {
    dlg.addEventListener('close', () => { h.classList.remove('lb-open', 'lb-fb'); if (pushed && history.state && history.state.iwgLb) closeLB(); }); /* Esc */
    dlg.addEventListener('click', (e) => { if (e.target === dlg) closeLB(); }); /* Tipp neben das Bild */
  }
  function toStage() {
    const el = $('konfigurator'); if (!el) return;
    scrollTo({ top: el.getBoundingClientRect().top + scrollY - 8, behavior: RM.matches ? 'auto' : 'smooth' });
  }
  /* eine Figur aus dem Bild uebernehmen: Charakter, Farbwelt, Stil, Name; Groesse und Material bleiben */
  function pickPrint(key, i) {
    const p = ROOMS[key].p[i], q = new URLSearchParams({ c: p[0], w: p[1], s: p[2], n: p[3] });
    const e = I.parse(q.toString());
    closeLB(() => {
      api.setState({ du: 0, c: e.c, w: e.w, s: e.s, n: e.n });
      setTimeout(toStage, 60);
      ev('iwg_room_pick', { room: key, char: p[0] });
    });
  }
  d.addEventListener('click', (e) => {
    const t = e.target;
    if (!t.closest) return;
    const lk = t.closest('[data-look]');
    if (lk) {
      const key = lk.getAttribute('data-look'), r = ROOMS[key];
      if (!r || !canLook(r)) return;
      const go = () => { if (api.takeLook(tokens(r), lk)) ev('iwg_room_wall', { room: key }); };
      if (dlg && dlg.hasAttribute('open')) closeLB(go); else go();
      return;
    }
    const pk = t.closest('[data-pick]');
    if (pk && lbKey) { pickPrint(lbKey, +pk.getAttribute('data-pick')); return; }
    if (t.closest('[data-lb-close]')) { closeLB(); return; }
    const lb = t.closest('[data-lb]');
    if (lb) { openLB(lb.getAttribute('data-lb'), lb); }
  });
})();

/* Handy: Charakter-Reihe faehrt von allein durch, damit man sieht, dass es mehr als 4 gibt.
   Stoppt endgueltig, sobald der Kunde die Reihe beruehrt, wischt oder etwas waehlt (Robin 29.10.). */
(() => {
  const row = document.getElementById('t-char');
  if (!row || !window.matchMedia) return;
  const MOB = matchMedia('(max-width:899px)');
  const RM = matchMedia('(prefers-reduced-motion: reduce)');
  const SPEED_R = 42, SPEED_L = 90, PAUSE = 1400, START = 1200; // px/s, ms
  let stopped = false, visible = false, raf = 0, last = 0, pos = 0, dir = 1, hold = 0, started = false;
  const can = () => !stopped && MOB.matches && !RM.matches && !document.hidden && visible &&
    row.scrollWidth > row.clientWidth + 4;
  function frame(t) {
    raf = 0;
    if (!can()) { row.style.scrollSnapType = ''; return; }
    const dt = Math.min(64, t - (last || t)); last = t;
    if (Math.abs(row.scrollLeft - pos) > 3) { stop(); return; } // Kunde hat selbst gescrollt
    if (hold > 0) { hold -= dt; } else {
      const max = row.scrollWidth - row.clientWidth;
      pos += dir * (dir > 0 ? SPEED_R : SPEED_L) * dt / 1000;
      if (pos >= max) { pos = max; dir = -1; hold = PAUSE; }
      if (pos <= 0) { pos = 0; dir = 1; hold = PAUSE; }
      row.scrollLeft = pos;
    }
    raf = requestAnimationFrame(frame);
  }
  function run() {
    if (raf || !can()) return;
    row.style.scrollSnapType = 'none';
    pos = row.scrollLeft; last = 0;
    raf = requestAnimationFrame(frame);
  }
  function stop() {
    if (stopped) return;
    stopped = true;
    if (raf) cancelAnimationFrame(raf);
    raf = 0;
    row.style.scrollSnapType = '';
  }
  ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin'].forEach((ev) =>
    row.addEventListener(ev, stop, { passive: true }));
  document.addEventListener('click', (e) => { if (e.target.closest && e.target.closest('#char-wrap, #tdu')) stop(); }, true);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) run(); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver((en) => { visible = en[0].isIntersecting; if (visible && started) run(); },
      { threshold: 0.6 }).observe(row);
  } else visible = true;
  setTimeout(() => { started = true; run(); }, START);
})();
